var _defs, _path, _rect, _g, _rect2, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g4, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g5, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g6, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g7, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _g8, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g9, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgALaCarte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 563 390.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 131.57,
    y1: -3,
    x2: 382.58,
    y2: 431.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6cc7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f68e30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef5456"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#74bbe7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413,391H0V176.31C0,80,97.06-15,174.33,2s-19.73,92,138.27,80c80.37-6.1,60-33,136-39S563,95.94,563,165.34V241A150,150,0,0,1,413,391Z",
    fill: "url(#linear-gradient)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.26,
    y: 18.98,
    width: 427.16,
    height: 49.26,
    rx: 12,
    fill: "#fff",
    stroke: "#1b0f44",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dots"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 20.23,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 23.12,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.68,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 63.03,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.09,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.87,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.65,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.43,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.21,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.99,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.77,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.55,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.33,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.11,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.89,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.45,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.23,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.01,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.79,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.56,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.34,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.12,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.9,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.31,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.95,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.72,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.5,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.28,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.06,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.84,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.62,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.18,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.96,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.74,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.52,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.3,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.08,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.86,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.64,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.42,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.2,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.98,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.17,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.53,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.78,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.56,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.34,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.12,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.9,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.68,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.23,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.01,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.79,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.57,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.35,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.91,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.69,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.47,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.25,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.03,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.81,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.59,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.37,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.63,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.41,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.19,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.97,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.75,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.53,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.31,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.09,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.87,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.65,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.42,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.2,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.98,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.76,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.32,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.1,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.88,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.66,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.44,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.85,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.22,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.89,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.67,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.45,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.23,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.01,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.79,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.57,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.35,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.13,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.91,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.69,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.47,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.25,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.02,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.36,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.14,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.92,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.7,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.11,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.48,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.74,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.52,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.3,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.08,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.86,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.64,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.42,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.2,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.98,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.76,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.54,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.32,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.1,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.88,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.66,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.44,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.22,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.99,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 431.77,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.55,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492.96,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 65.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 25.99,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 28.87,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 31.56,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 34.44,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 37.31,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 40.2,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 43.07,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 45.96,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 48.82,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 51.71,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 54.39,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 57.28,
    r: 0.8,
    fill: "#74bbe7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.92,
    cy: 60.15,
    r: 0.8,
    fill: "#74bbe7"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.26,
    y: 18.98,
    width: 427.16,
    height: 49.26,
    rx: 12,
    fill: "none",
    stroke: "#1b0f44",
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.07,42a1.17,1.17,0,0,1,.86.21.68.68,0,0,1,.28.73,44.51,44.51,0,0,1-5.14,6.64c-1.56,1.6-3,2.4-4.39,2.4-1.75,0-2.62-.92-2.62-2.76a9.83,9.83,0,0,1,.78-3.46c-2.34-.18-4.56-.28-6.68-.33q-3,5-3.27,7.78a3.33,3.33,0,0,1-2.61-.57,2.64,2.64,0,0,1-1.15-2.28q0-2.07,2.67-5.85a47.34,47.34,0,0,1,6.55-7.34,28.64,28.64,0,0,1,7.11-5,7,7,0,0,0-2.4-.36,12.54,12.54,0,0,0-4.57.89,14.9,14.9,0,0,0-3.88,2.2A12.86,12.86,0,0,0,224,37.7a5.36,5.36,0,0,0-1,2.89,4.52,4.52,0,0,0,.19,1.42,3.71,3.71,0,0,1-3-.26,2.75,2.75,0,0,1-1.39-2.62,6.08,6.08,0,0,1,2.48-4.57,17.75,17.75,0,0,1,6.07-3.34,22.38,22.38,0,0,1,7.1-1.2,11.29,11.29,0,0,1,6,1.41,4.3,4.3,0,0,1,2.28,3.81q0,1.82-1.8,6.22c-1.2,2.94-1.79,4.76-1.79,5.48,0,.56.19.84.58.84s1.23-.57,2.27-1.72A41.31,41.31,0,0,0,245.07,42Zm-14.54,1.39a20.51,20.51,0,0,1,5,.52c.28-.65.79-1.78,1.54-3.39s1.29-2.88,1.63-3.82a6.94,6.94,0,0,0,.52-2.32A2.15,2.15,0,0,0,239,33.2a42,42,0,0,0-9.46,10.2C229.71,43.38,230.05,43.37,230.53,43.37Zm10-14.68a4.34,4.34,0,0,1-2.8-1.06,2.88,2.88,0,0,1-1.32-2.05,1.33,1.33,0,0,1,.6-1.07,3.14,3.14,0,0,1,1.35-.58,8.68,8.68,0,0,0,1.73,2.79,4.06,4.06,0,0,0,1.77,1.36C241.76,28.49,241.32,28.69,240.54,28.69Z",
    fill: "#1b0f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.63,42a1.17,1.17,0,0,1,.86.21.68.68,0,0,1,.28.73,29.8,29.8,0,0,1-5.33,6q-2.9,2.43-5.27,2.43a3.23,3.23,0,0,1-2.38-1,3.77,3.77,0,0,1-.95-2.77,17.52,17.52,0,0,1,1.88-7,29.05,29.05,0,0,1,4.68-7.33q2.81-3.16,5.07-3.17a2.33,2.33,0,0,1,1.63.6,2,2,0,0,1,.67,1.57c0,1.71-1.07,4-3.19,6.79a30.39,30.39,0,0,1-6.82,6.75v.26a3,3,0,0,0,.42,1.7,1.33,1.33,0,0,0,1.16.63q1.34,0,3.36-1.83A26.53,26.53,0,0,0,262.63,42Zm-1.58-9.33q-1,0-3.42,3.84a29.41,29.41,0,0,0-3.45,7.17,28.67,28.67,0,0,0,4.76-5.44q2.43-3.47,2.43-4.92C261.37,32.86,261.26,32.65,261.05,32.65Z",
    fill: "#1b0f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,42a1.17,1.17,0,0,1,.86.21.68.68,0,0,1,.28.73q-5.44,7.68-8.3,7.68a2,2,0,0,1-1.75-1,3.94,3.94,0,0,1-.65-2.25,2.93,2.93,0,0,1,0-.52q-3.8,4.55-6,4.54a2.31,2.31,0,0,1-1.64-.75,3.07,3.07,0,0,1-.76-2.3,11.36,11.36,0,0,1,1-4.31A14,14,0,0,1,264,39.73a5.18,5.18,0,0,1,3.7-1.9,3.3,3.3,0,0,1,1.94.62,3.12,3.12,0,0,1,1.2,1.75c1-1.54,1.86-2.3,2.66-2.3a2.24,2.24,0,0,1,2,1.39,9.28,9.28,0,0,1-1,1.76,23.16,23.16,0,0,1-1.58,2.13,10.59,10.59,0,0,0-.56,2.91c0,.78.19,1.17.56,1.17C273.68,47.26,275.38,45.5,278,42Zm-13.25,5.93c.35,0,1-.47,1.9-1.4a28.23,28.23,0,0,0,2.77-3.33,16.44,16.44,0,0,1,.71-1.72c-.48-.91-1-1.36-1.56-1.36s-1.25.44-1.94,1.31a11.76,11.76,0,0,0-1.68,2.93,7.36,7.36,0,0,0-.65,2.63C264.29,47.59,264.44,47.91,264.74,47.91Z",
    fill: "#1b0f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.59,42.92A25.92,25.92,0,0,1,292,49.14a9.28,9.28,0,0,1-5.51,2.17,3.9,3.9,0,0,1-2.9-1.12,4,4,0,0,1-1.12-3A9.65,9.65,0,0,1,283.55,43a12.61,12.61,0,0,1,3-4,5.58,5.58,0,0,1,3.71-1.67,4.92,4.92,0,0,1,2.56.74,2.23,2.23,0,0,1,1.23,2,3.79,3.79,0,0,1-1.64,2.82c-1.09.9-2,1.22-2.8.94a9.81,9.81,0,0,0,1.52-4.12c0-.47-.17-.71-.51-.71s-.88.39-1.53,1.18a13.87,13.87,0,0,0-1.78,3,7.85,7.85,0,0,0-.81,3.18c0,1.4.61,2.11,1.82,2.11a6.76,6.76,0,0,0,4.24-2A21.45,21.45,0,0,0,296.46,42a1.18,1.18,0,0,1,.86.21A.65.65,0,0,1,297.59,42.92Z",
    fill: "#1b0f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.82,42a1.18,1.18,0,0,1,.86.21.67.67,0,0,1,.27.73q-5.44,7.68-8.29,7.68a2,2,0,0,1-1.75-1,3.87,3.87,0,0,1-.65-2.25,3.19,3.19,0,0,1,0-.52c-2.53,3-4.51,4.54-6,4.54a2.32,2.32,0,0,1-1.64-.75,3.11,3.11,0,0,1-.76-2.3,11.36,11.36,0,0,1,1-4.31,14,14,0,0,1,2.84-4.32,5.17,5.17,0,0,1,3.69-1.9,3.35,3.35,0,0,1,1.95.62,3.12,3.12,0,0,1,1.2,1.75c1-1.54,1.85-2.3,2.65-2.3a2,2,0,0,1,1.35.47,2,2,0,0,1,.69.92,9.08,9.08,0,0,1-1,1.76,21.45,21.45,0,0,1-1.59,2.13,10.51,10.51,0,0,0-.55,2.91c0,.78.18,1.17.55,1.17C307.51,47.26,309.2,45.5,311.82,42Zm-13.25,5.93c.34,0,1-.47,1.89-1.4a27.29,27.29,0,0,0,2.77-3.33,16.44,16.44,0,0,1,.71-1.72c-.47-.91-1-1.36-1.55-1.36s-1.25.44-1.94,1.31a11.49,11.49,0,0,0-1.69,2.93,7.58,7.58,0,0,0-.65,2.63C298.11,47.59,298.26,47.91,298.57,47.91Z",
    fill: "#1b0f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.58,42a1.18,1.18,0,0,1,.86.21.67.67,0,0,1,.27.73,33.9,33.9,0,0,1-4.94,6c-1.78,1.68-3.31,2.53-4.58,2.53a2.45,2.45,0,0,1-1.77-.73,2.48,2.48,0,0,1-.73-1.83,10.29,10.29,0,0,1,1.64-4.15A11.12,11.12,0,0,0,316,41c0-.47-.33-.88-1-1.23l-2,3.18a1.38,1.38,0,0,1-.79-.26.72.72,0,0,1-.34-.68,21.76,21.76,0,0,0,1.71-3,1.48,1.48,0,0,1-.77-1.2,2.22,2.22,0,0,1,.84-1.69,2.76,2.76,0,0,1,1.85-.74.89.89,0,0,1,1,1,3.86,3.86,0,0,1-.51,1.85,1.4,1.4,0,0,0,.32.24l.48.29c.2.12.37.23.52.34,1.45,1,2.17,1.82,2.17,2.46a8.17,8.17,0,0,1-1.15,2.95,8.52,8.52,0,0,0-1.15,2.92c0,.47.17.71.49.71.47,0,1.32-.63,2.53-1.91A34.9,34.9,0,0,0,323.58,42Z",
    fill: "#1b0f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,42a1.17,1.17,0,0,1,.86.21.65.65,0,0,1,.27.73,32.85,32.85,0,0,1-5.23,6q-2.76,2.43-4.91,2.43A3.1,3.1,0,0,1,321.83,48q0-2.62,2.4-7.58h-.13a1.25,1.25,0,0,1-1.1-.83c-.29-.55-.31-1-.07-1.25a9.54,9.54,0,0,0,2.3.07,24.17,24.17,0,0,1,2.88-4.26c1-1.12,1.82-1.67,2.53-1.67a2.2,2.2,0,0,1,1.15.35,1.87,1.87,0,0,1,.76.81A20.49,20.49,0,0,0,329.34,38l.82-.09.79-.1.47,0a1.33,1.33,0,0,1,1.26.68,1.57,1.57,0,0,1,.16,1.36c-.38,0-1.16.1-2.31.16s-2,.12-2.42.16q-2.3,4.44-2.3,6.71c0,1,.35,1.52,1,1.52s1.88-.59,3.18-1.78A30.87,30.87,0,0,0,334,42Z",
    fill: "#1b0f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.87,42a1.18,1.18,0,0,1,.86.21.65.65,0,0,1,.27.73q-6,8.38-11.27,8.39a4.17,4.17,0,0,1-3.06-1.09,3.91,3.91,0,0,1-1.12-3,9.68,9.68,0,0,1,1.12-4.21,12.7,12.7,0,0,1,3-4,5.73,5.73,0,0,1,3.77-1.68,4.05,4.05,0,0,1,2.55.84,2.46,2.46,0,0,1,1.08,2c0,1.06-.71,2.25-2.14,3.59A15.51,15.51,0,0,1,335.53,47a1.71,1.71,0,0,0,1.88,1.52,7.24,7.24,0,0,0,4.41-2.07A21.09,21.09,0,0,0,345.87,42Zm-6.12-3c-.59,0-1.38.78-2.39,2.33a11.77,11.77,0,0,0-1.83,4.28,12.92,12.92,0,0,0,3.39-2.85,5,5,0,0,0,1.44-2.95C340.36,39.27,340.16,39,339.75,39Z",
    fill: "#1b0f44"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109,79.15a2.13,2.13,0,0,1,1.16,1.46,1.74,1.74,0,0,1-.61,1.54,3.33,3.33,0,0,1-1.93.83,6.49,6.49,0,0,1-.78.06,7,7,0,0,1-1-.06l-.87-.1-1.09-.17-1-.15a31.15,31.15,0,0,0-3.95,8c1.81-.48,2.74-.74,2.79-.77s.34-.14.72-.32.74-.34,1.07-.47a4,4,0,0,1,.86-.25,2.06,2.06,0,0,1,1.1.19,16.35,16.35,0,0,0-1,2.59,16,16,0,0,0-.6,2.75.87.87,0,0,1-1-.17,2.15,2.15,0,0,1-.52-1.27,4.39,4.39,0,0,1,0-1l-1.5.16c-1.24.16-2.09.28-2.52.35q-2,6.08-1.6,8.86a3.94,3.94,0,0,1-1.21.3,3,3,0,0,1-2.11-.39,2.2,2.2,0,0,1-1-1.64,13.57,13.57,0,0,1,1-5.44,43.76,43.76,0,0,1,3.19-7.18,14.69,14.69,0,0,1,3.43-4.56,14.32,14.32,0,0,0-2.16.1,9.31,9.31,0,0,0-3.78,1.29A6.76,6.76,0,0,0,91.8,86a10.35,10.35,0,0,0-1,2.75,8,8,0,0,0-.13,2.65,3.7,3.7,0,0,0,.83,2.15,4.72,4.72,0,0,1-1.13.32,3.41,3.41,0,0,1-2.56-.57,3.56,3.56,0,0,1-1.26-2.54c-.28-2.25.58-4.34,2.59-6.3a14.07,14.07,0,0,1,8.29-3.59c.74-.1,2.13-.19,4.16-.27a44.53,44.53,0,0,0,5-.43A3.86,3.86,0,0,0,109,79.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.09,89a1,1,0,0,1,.78.09.58.58,0,0,1,.33.62,30.28,30.28,0,0,1-3.71,5.85q-2.08,2.55-3.79,2.76a2.17,2.17,0,0,1-1.65-.44,2.24,2.24,0,0,1-.85-1.55,9.09,9.09,0,0,1,1-3.86,9.85,9.85,0,0,0,1-3.5c0-.42-.38-.75-1-1l-1.45,3a1.19,1.19,0,0,1-.73-.14.62.62,0,0,1-.38-.57,20.33,20.33,0,0,0,1.18-2.86,1.34,1.34,0,0,1-.83-1,2,2,0,0,1,.56-1.59,2.39,2.39,0,0,1,1.56-.87.81.81,0,0,1,1,.77,3.35,3.35,0,0,1-.25,1.7,1.33,1.33,0,0,0,.31.18l.47.2.5.25c1.39.71,2.13,1.36,2.2,1.94a7.44,7.44,0,0,1-.68,2.74,7.69,7.69,0,0,0-.7,2.72c.06.43.23.62.52.58s1.1-.71,2-2A31.24,31.24,0,0,0,118.09,89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62,87.7a1,1,0,0,1,.78.09.61.61,0,0,1,.33.62q-4.39,8.13-9.06,8.72a3.74,3.74,0,0,1-2.84-.61A3.52,3.52,0,0,1,116.5,94a8.74,8.74,0,0,1,.52-3.86,11.28,11.28,0,0,1,2.22-3.88,5.15,5.15,0,0,1,3.16-1.93,3.63,3.63,0,0,1,2.35.46,2.2,2.2,0,0,1,1.19,1.64c.12.94-.38,2.08-1.49,3.43A14,14,0,0,1,120,93.33a1.53,1.53,0,0,0,1.84,1.14,6.52,6.52,0,0,0,3.68-2.34A18.88,18.88,0,0,0,128.62,87.7Zm-5.78-2c-.51.07-1.13.85-1.85,2.34a10.56,10.56,0,0,0-1.14,4,11.25,11.25,0,0,0,2.68-2.91,4.46,4.46,0,0,0,1-2.78C123.42,85.92,123.21,85.7,122.84,85.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,86.38a1,1,0,0,1,.79.09.58.58,0,0,1,.32.61,8.14,8.14,0,0,1-4.41,4.13,4.64,4.64,0,0,1-1.12,3.26A4.4,4.4,0,0,1,131.77,96a3.81,3.81,0,0,1-3.48-1.31,6,6,0,0,1-1.67-3.35c-.17-1.32.21-1.93,1.14-1.81a13.44,13.44,0,0,0,4.32.85c-.43-2.89-.66-4.53-.69-4.94l-.13-.1q-.1.28-1.53,3.12a1.26,1.26,0,0,1-.73-.14.65.65,0,0,1-.38-.57,40.78,40.78,0,0,0,1.9-3.89,2,2,0,0,1,1.95-1.57c1.08-.13,1.79.07,2.14.61a3.93,3.93,0,0,0-.25,1.87,16.16,16.16,0,0,0,.59,2.79c.33,1.17.53,1.88.58,2.15A7.44,7.44,0,0,0,139,86.38ZM131,93.6a1.32,1.32,0,0,0,1-.62,2.23,2.23,0,0,0,.36-1.16,9.77,9.77,0,0,1-4.24-.89,4.22,4.22,0,0,0,1.28,2.1A2.14,2.14,0,0,0,131,93.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.9,84.61a1,1,0,0,1,.78.09.6.6,0,0,1,.33.62,26.64,26.64,0,0,1-3.56,5.42c-1.29,1.47-2.46,2.27-3.51,2.41a1.75,1.75,0,0,1-1.41-.37,2.18,2.18,0,0,1-.7-1.47q-.26-2,2-6.86l-.07-.08a19.47,19.47,0,0,0-3.41,4.54,24.48,24.48,0,0,0-2.79,5.52,3,3,0,0,1-.6.14,2.2,2.2,0,0,1-2.5-2,16.1,16.1,0,0,1,1.06-5.91A44,44,0,0,1,141.71,79c1.3-2.39,2.4-3.65,3.32-3.77a2.6,2.6,0,0,1,1.3.19,1.75,1.75,0,0,1,.88.62,26.32,26.32,0,0,0-4.16,7.15,37.89,37.89,0,0,0-2.48,7.7,45.65,45.65,0,0,1,3.93-6.16q2.37-3.15,3.4-3.28a2.42,2.42,0,0,1,1.46.29,1.77,1.77,0,0,1,.93,1,15.89,15.89,0,0,0-1.4,3.31,7.68,7.68,0,0,0-.52,3c.08.59.24.87.49.84.42,0,1-.58,1.76-1.57A27,27,0,0,0,152.9,84.61Z",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.81,108.37v.08a4.47,4.47,0,0,1-4.45,4.45h-1.6v8.25h-.4V104.23a.18.18,0,0,1,.06-.13.2.2,0,0,1,.15-.06h1.79a4.4,4.4,0,0,1,3.15,1.25A4.14,4.14,0,0,1,45.81,108.37Zm-.4.08v-.08a3.72,3.72,0,0,0-1.18-2.8,4,4,0,0,0-2.87-1.13h-1.6v8.06h1.6a4.06,4.06,0,0,0,4-4Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.48,120.78v.39H47.76V104h6.58v.4H48.18v7.87h6.16v.42H48.18v8Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65,104v.4h-4v16.71H60.7V104.44h-4V104Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.14,112.31v.42H74v8.44h-.44V104h6.57v.4H74v7.87Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.44,112.46a8.78,8.78,0,0,1-.74,3.59,9.15,9.15,0,0,1-2,2.93,9.54,9.54,0,0,1-3,1.94,9.41,9.41,0,0,1-7.22,0,9.81,9.81,0,0,1-3-1.93,9.28,9.28,0,0,1-2-2.89,8.58,8.58,0,0,1-.75-3.53,8.45,8.45,0,0,1,.75-3.51,9.14,9.14,0,0,1,2-2.89,9.64,9.64,0,0,1,10.23-2,9.29,9.29,0,0,1,2.94,1.87,8.85,8.85,0,0,1,2.73,6.39Zm-.37.11a8.29,8.29,0,0,0-1.2-4.35,8.68,8.68,0,0,0-3.26-3.16,9.23,9.23,0,0,0-9,0,8.72,8.72,0,0,0-3.25,3.16,8.41,8.41,0,0,0-.49,7.71,8.66,8.66,0,0,0,1.91,2.78,9.13,9.13,0,0,0,9.8,1.85,9.12,9.12,0,0,0,2.86-1.86,8.87,8.87,0,0,0,1.9-2.77A8.32,8.32,0,0,0,100.07,112.57Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.43,112.46a8.78,8.78,0,0,1-.74,3.59,9.15,9.15,0,0,1-2,2.93,9.42,9.42,0,0,1-3,1.94,9.39,9.39,0,0,1-7.21,0,9.57,9.57,0,0,1-3-1.93,9.14,9.14,0,0,1-2-2.89,8.57,8.57,0,0,1-.74-3.53,8.44,8.44,0,0,1,.74-3.51,9.14,9.14,0,0,1,2-2.89,9.61,9.61,0,0,1,13.18-.1,8.78,8.78,0,0,1,2,2.85A8.58,8.58,0,0,1,120.43,112.46Zm-.37.11a8.29,8.29,0,0,0-1.2-4.35,8.72,8.72,0,0,0-3.25-3.16,9.06,9.06,0,0,0-4.5-1.16,8.89,8.89,0,0,0-4.48,1.17,8.68,8.68,0,0,0-3.26,3.16,8.41,8.41,0,0,0-.49,7.71,8.66,8.66,0,0,0,1.91,2.78,9.15,9.15,0,0,0,9.81,1.85,9.19,9.19,0,0,0,2.85-1.86,8.87,8.87,0,0,0,1.9-2.77A8.32,8.32,0,0,0,120.06,112.57Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.54,109.3a8.39,8.39,0,0,1,0,6.71,8.61,8.61,0,0,1-4.64,4.6,8.35,8.35,0,0,1-3.33.69,9.46,9.46,0,0,1-1.07-.06V104h.15c.13,0,.4,0,.81,0a9,9,0,0,1,6.21,2.52A8.86,8.86,0,0,1,131.54,109.3Zm-.38,6.56a8.11,8.11,0,0,0,0-6.41,8.31,8.31,0,0,0-1.8-2.63,8.55,8.55,0,0,0-2.68-1.76,8.36,8.36,0,0,0-3.28-.66,2.51,2.51,0,0,0-.48,0v16.44a3.11,3.11,0,0,0,.48,0,8.35,8.35,0,0,0,3.28-.65,8.55,8.55,0,0,0,2.68-1.76A8.31,8.31,0,0,0,131.16,115.86Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.11,119.11l.32.24a9.73,9.73,0,0,1-2.86,1.67,9.66,9.66,0,0,1-7-.12,9.5,9.5,0,0,1-3-1.92,9.16,9.16,0,0,1-2-2.87,8.75,8.75,0,0,1,.51-8,9.15,9.15,0,0,1,3.4-3.28,9.68,9.68,0,0,1,10.39.67l-.22.32a9.21,9.21,0,0,0-11.82.71,8.55,8.55,0,0,0-1.9,2.76,8,8,0,0,0-.71,3.35,8.29,8.29,0,0,0,1.19,4.32,8.75,8.75,0,0,0,3.26,3.13,9,9,0,0,0,4.48,1.16,9.18,9.18,0,0,0,3.18-.56A8.81,8.81,0,0,0,155.11,119.11Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.8,112.9h-1.36l6.65,8.14-.31.28-6.58-8.09v7.92h-.39V104.23a.18.18,0,0,1,.06-.13A.17.17,0,0,1,158,104h1.79a4.37,4.37,0,0,1,3.15,1.25,4.1,4.1,0,0,1,1.3,3.08v.08a4.47,4.47,0,0,1-4.45,4.45Zm4-4.45v-.08a3.72,3.72,0,0,0-1.18-2.8,4,4,0,0,0-2.87-1.13h-1.6v8.06h1.6a4.06,4.06,0,0,0,4-4Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173.93,120.78v.39h-6.71V104h6.57v.4h-6.15v7.87h6.15v.42h-6.15v8Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M185.74,109.3a8.5,8.5,0,0,1,0,6.71,8.61,8.61,0,0,1-4.64,4.6,8.35,8.35,0,0,1-3.33.69,9.51,9.51,0,0,1-1.08-.06V104h.15c.13,0,.4,0,.82,0a8.72,8.72,0,0,1,8.08,5.28Zm-.39,6.56a8,8,0,0,0,0-6.41,8.12,8.12,0,0,0-1.79-2.63,8.59,8.59,0,0,0-2.69-1.76,8.32,8.32,0,0,0-3.28-.66,2.68,2.68,0,0,0-.48,0v16.44a3.18,3.18,0,0,0,.48,0,8.31,8.31,0,0,0,3.28-.65,8.59,8.59,0,0,0,2.69-1.76A8.12,8.12,0,0,0,185.35,115.86Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.88,104v17.11h-.37V104Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.43,104v.4h-3.94v16.71h-.39V104.44h-4V104Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.6,165.25a4.6,4.6,0,0,1-1.63,4,15.08,15.08,0,0,1-4.87,3.09,8.24,8.24,0,0,1,3.55,1.23,3.25,3.25,0,0,1,1.58,2.3c.17,1.36-.59,2.73-2.3,4.09a12.21,12.21,0,0,1-6.24,2.52,7,7,0,0,1-4.36-.57,3.8,3.8,0,0,1-1.89-3,12.57,12.57,0,0,1,.84-5.5,21.72,21.72,0,0,1,2.94-5.81q1.83-2.52,3.38-2.72a1.74,1.74,0,0,1,1.68.54,30.17,30.17,0,0,0-3.64,7,13.09,13.09,0,0,0,3.24-1.2,9,9,0,0,0,2.92-2.45,4.35,4.35,0,0,0,1-3.37c-.27-2.15-1.89-3-4.84-2.66a10.64,10.64,0,0,0-4.27,1.49,11.39,11.39,0,0,0-3.13,2.72,12.68,12.68,0,0,0-1.77,3.1,5.8,5.8,0,0,0-.46,2.71,3.31,3.31,0,0,0,.58,1.57,2.52,2.52,0,0,1-1,.31,3,3,0,0,1-2.24-.61,3.32,3.32,0,0,1-1.24-2.37,6.23,6.23,0,0,1,1.24-4.38,12.8,12.8,0,0,1,4.54-3.84A19.09,19.09,0,0,1,76,161.27a12.56,12.56,0,0,1,6.73.63A4.27,4.27,0,0,1,85.6,165.25Zm-5.28,10.17a1.74,1.74,0,0,0-1.62-1.55,17.07,17.07,0,0,0-4.61.15,10.47,10.47,0,0,0-.69,4.24,1.9,1.9,0,0,0,2.41,1.89,5.48,5.48,0,0,0,3.29-1.71A3.66,3.66,0,0,0,80.32,175.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.16,169.1a1.11,1.11,0,0,1,.81.08.55.55,0,0,1,.3.63,6.51,6.51,0,0,1-2.1,2.51,6.24,6.24,0,0,1-2.73,1.09,2.44,2.44,0,0,1-.44,0,12.65,12.65,0,0,1-2.5,3.77A5.56,5.56,0,0,1,89.22,179a3.13,3.13,0,0,1-2.45-.64A3.5,3.5,0,0,1,85.56,176a9.05,9.05,0,0,1,.42-3.72,10.72,10.72,0,0,1,2-3.81,4.71,4.71,0,0,1,3-1.9,3.78,3.78,0,0,1,1.6.14,2.33,2.33,0,0,1,1.66-1.2,1.44,1.44,0,0,1,1.24.42,2.84,2.84,0,0,1,.67,1.67,9.67,9.67,0,0,1-.49,4A4.59,4.59,0,0,0,99.16,169.1Zm-8.78,7.06a2.57,2.57,0,0,0,1.5-1,9.07,9.07,0,0,0,1.39-2.27A3.73,3.73,0,0,1,92,170.25a6.43,6.43,0,0,1,.09-2.23c-.75,0-1.48.88-2.2,2.47a8,8,0,0,0-.84,4.17C89.19,175.75,89.63,176.25,90.38,176.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.42,167.92a1.07,1.07,0,0,1,.79.09.61.61,0,0,1,.33.62,29.71,29.71,0,0,1-4,5.89c-1.45,1.64-2.81,2.55-4.08,2.71a2.78,2.78,0,0,1-2.1-.54,2.84,2.84,0,0,1-1.09-2c-.2-1.55.23-3.89,1.27-7h-.11a1.12,1.12,0,0,1-1.07-.61c-.31-.45-.38-.82-.2-1.1a8,8,0,0,0,2-.2,21.77,21.77,0,0,1,2.08-4.11c.73-1.1,1.42-1.68,2-1.77a1.92,1.92,0,0,1,1.06.19,1.72,1.72,0,0,1,.77.63,18.17,18.17,0,0,0-2.36,4.19l.71-.18.69-.17.42-.08a1.19,1.19,0,0,1,1.19.46,1.39,1.39,0,0,1,.3,1.19c-.34.08-1,.22-2,.4s-1.72.33-2.12.42q-1.55,4.2-1.28,6.22c.11.9.47,1.31,1.09,1.23a4.86,4.86,0,0,0,2.62-1.94A27,27,0,0,0,108.42,167.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.06,166.19a1,1,0,0,1,.79.09.58.58,0,0,1,.32.61q-4,7.44-6.49,7.76A1.84,1.84,0,0,1,115,174a3.58,3.58,0,0,1-.83-1.93c0-.21,0-.36,0-.46q-2.85,4.45-4.78,4.7a2,2,0,0,1-1.53-.48,2.75,2.75,0,0,1-.94-2,10.19,10.19,0,0,1,.42-3.94,12.63,12.63,0,0,1,2-4.17,4.7,4.7,0,0,1,3.06-2.1,3,3,0,0,1,1.8.33,2.8,2.8,0,0,1,1.26,1.42c.69-1.47,1.39-2.26,2.1-2.35a1.92,1.92,0,0,1,1.25.27,1.79,1.79,0,0,1,.72.74,8.15,8.15,0,0,1-.69,1.68,21.24,21.24,0,0,1-1.17,2.07,9.59,9.59,0,0,0-.16,2.65c.09.69.29,1,.62,1Q119.18,171.32,122.06,166.19ZM111,173c.31,0,.82-.52,1.53-1.45a24.86,24.86,0,0,0,2.08-3.28,14.08,14.08,0,0,1,.44-1.6c-.53-.76-1-1.1-1.53-1s-1.07.53-1.58,1.39a10.3,10.3,0,0,0-1.17,2.79,6.92,6.92,0,0,0-.28,2.41C110.53,172.72,110.69,173,111,173Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,164.42a1,1,0,0,1,.79.09.6.6,0,0,1,.33.61,26.49,26.49,0,0,1-3.55,5.42c-1.28,1.47-2.45,2.28-3.53,2.41a1.75,1.75,0,0,1-1.39-.36,2.2,2.2,0,0,1-.68-1.48c-.18-1.38.48-3.66,2-6.85l-.1-.08a19.43,19.43,0,0,0-3.32,4.52,24,24,0,0,0-2.71,5.51,2.18,2.18,0,0,1-2,.13,2.07,2.07,0,0,1-1.22-1.82,11.08,11.08,0,0,1,.36-3.71,19.24,19.24,0,0,1,1.48-4.3c.64-1.28,1.24-2,1.82-2a2.33,2.33,0,0,1,1.14.16,1.67,1.67,0,0,1,.86.64,16.06,16.06,0,0,0-1.47,3.24,14.76,14.76,0,0,0-.92,4.14,49.44,49.44,0,0,1,3.86-6.15q2.3-3.15,3.33-3.28a2.4,2.4,0,0,1,1.45.3,1.78,1.78,0,0,1,.94,1,16.43,16.43,0,0,0-1.4,3.36,8.1,8.1,0,0,0-.5,3.11c.06.45.22.67.47.64.44-.06,1-.58,1.78-1.57A25.77,25.77,0,0,0,136,164.42Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.62,164.29a31.41,31.41,0,0,1-3.46,5.74c-1.16,1.49-2.23,2.29-3.21,2.42a2.26,2.26,0,0,1-1.61-.44,2.49,2.49,0,0,1-.93-1.81,10.69,10.69,0,0,1,.4-3.71,18.77,18.77,0,0,1,1.57-4.2c.66-1.26,1.28-1.92,1.86-2a2.18,2.18,0,0,1,1.21.15,1.63,1.63,0,0,1,.75.62,15.63,15.63,0,0,0-1.56,3.46,8.88,8.88,0,0,0-.68,3.9c.07.56.26.81.59.77q1.19-.15,4-5.62a1.07,1.07,0,0,1,.79.09A.59.59,0,0,1,143.62,164.29Zm-3-5.58a1.47,1.47,0,0,1-1.17-.29,1.7,1.7,0,0,1-.63-1.18,3.81,3.81,0,0,1,.36-2,1.71,1.71,0,0,1,1.31-1.19,2.18,2.18,0,0,1,1.6.41c.49.34.75.66.79.95a4.39,4.39,0,0,0-1.22,1.35A9.55,9.55,0,0,0,140.61,158.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.9,163a23.25,23.25,0,0,1-4.31,6.16,8.32,8.32,0,0,1-4.64,2.55,3.54,3.54,0,0,1-2.7-.66,3.6,3.6,0,0,1-1.33-2.51,8.79,8.79,0,0,1,.52-3.87,11.44,11.44,0,0,1,2.19-3.86,5,5,0,0,1,3.11-1.9,4.47,4.47,0,0,1,2.36.37,2,2,0,0,1,1.31,1.59,3.38,3.38,0,0,1-1.14,2.69c-.86.93-1.66,1.31-2.38,1.15a8.82,8.82,0,0,0,.89-3.83q-.09-.63-.54-.57c-.33,0-.73.45-1.22,1.22a12.11,12.11,0,0,0-1.25,2.84,7.15,7.15,0,0,0-.36,2.91c.16,1.24.78,1.8,1.85,1.66a6,6,0,0,0,3.54-2.25,18.86,18.86,0,0,0,3-4.4,1.07,1.07,0,0,1,.79.09A.61.61,0,0,1,153.9,163Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.42,160.54a1,1,0,0,1,.78.09.58.58,0,0,1,.33.61q-4,7.44-6.5,7.76a1.83,1.83,0,0,1-1.66-.65,3.58,3.58,0,0,1-.83-1.93c0-.21,0-.36,0-.46-1.9,3-3.49,4.53-4.78,4.7a2,2,0,0,1-1.53-.48,2.75,2.75,0,0,1-.94-2,10.24,10.24,0,0,1,.42-3.95,12.68,12.68,0,0,1,2-4.16,4.67,4.67,0,0,1,3.06-2.1,3,3,0,0,1,1.8.33,2.8,2.8,0,0,1,1.26,1.42c.69-1.47,1.39-2.26,2.1-2.35a1.87,1.87,0,0,1,1.25.27,1.79,1.79,0,0,1,.72.74,9.53,9.53,0,0,1-.69,1.68,21.24,21.24,0,0,1-1.17,2.07,9.21,9.21,0,0,0-.16,2.65c.09.69.29,1,.62,1Q163.54,165.67,166.42,160.54Zm-11.1,6.76c.31,0,.82-.52,1.53-1.45a24.86,24.86,0,0,0,2.08-3.28,14.08,14.08,0,0,1,.44-1.6c-.53-.76-1-1.1-1.54-1s-1.06.53-1.57,1.39a10.3,10.3,0,0,0-1.17,2.79,6.92,6.92,0,0,0-.28,2.41Q154.92,167.34,155.32,167.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.88,159.33a1.07,1.07,0,0,1,.79.09.61.61,0,0,1,.33.62,26.74,26.74,0,0,1-4.06,5.89,7.72,7.72,0,0,1-4.4,2.76,3,3,0,0,1-2.23-.58,3.42,3.42,0,0,1-1.16-2.36,15.92,15.92,0,0,1,.88-6.42,26,26,0,0,1,3.33-7q2.13-3.13,4.14-3.4a2.14,2.14,0,0,1,1.52.35,1.81,1.81,0,0,1,.77,1.32q.28,2.28-2.07,6.39a27.32,27.32,0,0,1-5.29,6.77l0,.23a2.68,2.68,0,0,0,.57,1.46,1.16,1.16,0,0,0,1.11.43,5.16,5.16,0,0,0,2.77-2A23.59,23.59,0,0,0,175.88,159.33Zm-2.46-8.1q-.87.11-2.6,3.79a26.53,26.53,0,0,0-2.26,6.76,25.22,25.22,0,0,0,3.62-5.37c1.17-2.23,1.71-3.78,1.6-4.65C173.73,151.38,173.61,151.2,173.42,151.23Z",
    fill: "#fff"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73,190v.42H66.86v8.44h-.44V181.69H73v.4H66.86V190Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.91,190.55H76.55l6.65,8.14-.31.28-6.58-8.09v7.92h-.4V181.88a.18.18,0,0,1,.06-.13.2.2,0,0,1,.15-.06h1.79a4.4,4.4,0,0,1,3.15,1.25,4.09,4.09,0,0,1,1.3,3.08v.08a4.47,4.47,0,0,1-4.45,4.45Zm4-4.45V186a3.71,3.71,0,0,0-1.18-2.8,4,4,0,0,0-2.87-1.13h-1.6v8.06h1.6a4.06,4.06,0,0,0,4-4.05Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.39,181.18h.18l5.35,17.64h-.4L92,190.68H87l-2.37,8.14h-.42Zm.07,1.1-2.35,8h4.81Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.19,190.07v.17a8.74,8.74,0,0,1-.34,2.39,9.26,9.26,0,0,1-4.28,5.4,9,9,0,0,1-2.23.91,9.79,9.79,0,0,1-2.47.32,9.53,9.53,0,0,1-3.62-.71,9.35,9.35,0,0,1-3-1.93,9.16,9.16,0,0,1-2-2.87,8.77,8.77,0,0,1,.51-8,9.07,9.07,0,0,1,3.4-3.28,9.64,9.64,0,0,1,10.42.71l-.33.28a9.06,9.06,0,0,0-8.89-1.11,8.53,8.53,0,0,0-4.73,4.58,8.34,8.34,0,0,0,0,6.69,8.57,8.57,0,0,0,1.9,2.74,9.13,9.13,0,0,0,6.3,2.52,9.14,9.14,0,0,0,3.43-.66,9.34,9.34,0,0,0,2.84-1.77,8.26,8.26,0,0,0,1.91-2.66,7.7,7.7,0,0,0,.72-3.26H106v-.42Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M118.4,190.55H117l6.65,8.14-.31.28-6.57-8.09v7.92h-.4V181.88a.18.18,0,0,1,.06-.13.2.2,0,0,1,.14-.06h1.8a4.4,4.4,0,0,1,3.15,1.25,4.12,4.12,0,0,1,1.3,3.08v.08a4.47,4.47,0,0,1-4.45,4.45Zm4-4.45V186a3.75,3.75,0,0,0-1.18-2.8,4,4,0,0,0-2.87-1.13h-1.6v8.06h1.6a4.06,4.06,0,0,0,4-4.05Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M129.88,181.18h.17l5.35,17.64H135l-2.49-8.14h-5l-2.38,8.14h-.42Zm.07,1.1-2.36,8h4.82Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.17,181.67V198.8h-.38l-9.35-16.46V198.8h-.35V181.65h.35l9.35,16.42v-16.4Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M164.46,196.76l.32.24a9.47,9.47,0,0,1-6.19,2.26,9.61,9.61,0,0,1-6.6-2.63,9.16,9.16,0,0,1-2-2.87,8.75,8.75,0,0,1,.51-8,9.15,9.15,0,0,1,3.4-3.28,9.68,9.68,0,0,1,10.39.67l-.21.32a9,9,0,0,0-5.5-1.82,8.88,8.88,0,0,0-3.47.69,8.74,8.74,0,0,0-2.86,1.84,8.62,8.62,0,0,0-1.9,2.75,8.33,8.33,0,0,0,.49,7.67,8.67,8.67,0,0,0,3.25,3.14,9.37,9.37,0,0,0,7.66.6A8.81,8.81,0,0,0,164.46,196.76Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M173.87,198.42v.4h-6.71V181.69h6.57v.4h-6.15V190h6.15v.42h-6.15v8Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.73,262.64a6.32,6.32,0,0,1-5.06-1.26,7,7,0,0,1-2.36-4.7,11.78,11.78,0,0,1,.49-5A16,16,0,0,1,81.15,247,14.68,14.68,0,0,1,85,243.28a11.07,11.07,0,0,1,4.79-1.86,5.74,5.74,0,0,1,3.87.62,3.6,3.6,0,0,1,1.67,2.71,7.23,7.23,0,0,1-5.61,7.35,2,2,0,0,1-1.84-.45,2.08,2.08,0,0,1-.45-1.65A5.39,5.39,0,0,0,91,247.5a5.16,5.16,0,0,0,1.32-3.41c-.08-1-.69-1.35-1.84-1.2A7.12,7.12,0,0,0,86.5,245a13.75,13.75,0,0,0-3.15,4.76,10.78,10.78,0,0,0-.83,5.53A5.09,5.09,0,0,0,84,258.59a3.87,3.87,0,0,0,3.22.82q5.15-.66,9.24-8.05a1,1,0,0,1,.78.09.6.6,0,0,1,.33.62Q92.55,261.76,85.73,262.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,249.63a1,1,0,0,1,.78.09.62.62,0,0,1,.33.62q-3.91,7.42-6.55,7.76a1.88,1.88,0,0,1-1.5-.45,2.64,2.64,0,0,1-.8-1.74,4.65,4.65,0,0,1,0-.87c-1.91,2.8-3.52,4.28-4.85,4.45a2.08,2.08,0,0,1-1.56-.45,2.57,2.57,0,0,1-.89-1.81,11.18,11.18,0,0,1,.37-3.91,17,17,0,0,1,1.54-4.16c.66-1.2,1.28-1.84,1.88-1.92a2.48,2.48,0,0,1,1.18.17,1.77,1.77,0,0,1,.82.6,15.56,15.56,0,0,0-1.54,3.44,9.23,9.23,0,0,0-.68,4c.07.52.25.76.56.72q1-.14,3.31-3.84a15.5,15.5,0,0,1,1.36-3.93c.58-1.14,1.2-1.75,1.85-1.83a1.87,1.87,0,0,1,1.16.23,1.34,1.34,0,0,1,.73.78,13.42,13.42,0,0,1-1.72,3.26,10.18,10.18,0,0,0-.27,3.19c.09.66.32,1,.7.91Q107.21,254.76,110,249.63Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.42,248.31a1,1,0,0,1,.79.09.58.58,0,0,1,.32.61,8.13,8.13,0,0,1-4.41,4.13A4.64,4.64,0,0,1,116,256.4a4.48,4.48,0,0,1-2.84,1.49,3.86,3.86,0,0,1-3.48-1.31,6,6,0,0,1-1.67-3.36c-.17-1.32.21-1.93,1.14-1.81a13.44,13.44,0,0,0,4.32.85c-.43-2.89-.66-4.53-.69-4.94l-.13-.1q-.11.28-1.53,3.12a1.22,1.22,0,0,1-.74-.14.63.63,0,0,1-.37-.57c.92-1.73,1.56-3,1.9-3.89a2,2,0,0,1,2-1.57c1.08-.13,1.79.07,2.13.61a4.06,4.06,0,0,0-.24,1.87,14.93,14.93,0,0,0,.59,2.79c.33,1.17.53,1.88.58,2.15A7.44,7.44,0,0,0,120.42,248.31Zm-8.06,7.22a1.28,1.28,0,0,0,1-.62,2.12,2.12,0,0,0,.37-1.15,9.92,9.92,0,0,1-4.24-.9,4.23,4.23,0,0,0,1.28,2.11A2.16,2.16,0,0,0,112.36,255.53Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.68,247.13a1,1,0,0,1,.79.09.58.58,0,0,1,.32.61,29.26,29.26,0,0,1-4,5.89q-2.17,2.47-4.08,2.71a2.77,2.77,0,0,1-3.19-2.54c-.2-1.56.23-3.89,1.27-7l-.11,0a1.11,1.11,0,0,1-1.07-.61c-.32-.46-.38-.83-.2-1.1a8.54,8.54,0,0,0,2-.21,20.8,20.8,0,0,1,2.08-4.1c.73-1.1,1.42-1.69,2.05-1.77a2,2,0,0,1,1.06.18,1.73,1.73,0,0,1,.77.64,18,18,0,0,0-2.36,4.19l.71-.18.69-.18.41-.08a1.2,1.2,0,0,1,1.2.46,1.47,1.47,0,0,1,.3,1.19c-.34.08-1,.22-2,.41l-2.12.41q-1.55,4.22-1.29,6.22c.12.9.48,1.31,1.1,1.23a4.76,4.76,0,0,0,2.61-1.94A26.73,26.73,0,0,0,129.68,247.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.74,245.59a1.17,1.17,0,0,1,.81.07.57.57,0,0,1,.3.64,6.5,6.5,0,0,1-2.11,2.5,6.15,6.15,0,0,1-2.72,1.1,2.47,2.47,0,0,1-.44,0,12.84,12.84,0,0,1-2.5,3.77,5.56,5.56,0,0,1-3.29,1.76,3.11,3.11,0,0,1-2.45-.63,3.49,3.49,0,0,1-1.2-2.38,9.2,9.2,0,0,1,.41-3.72,11,11,0,0,1,2-3.81,4.79,4.79,0,0,1,3-1.91,3.79,3.79,0,0,1,1.6.15,2.29,2.29,0,0,1,1.66-1.2,1.38,1.38,0,0,1,1.23.42,2.81,2.81,0,0,1,.67,1.67,9.49,9.49,0,0,1-.48,4A4.63,4.63,0,0,0,141.74,245.59ZM133,252.65a2.6,2.6,0,0,0,1.49-1,9,9,0,0,0,1.39-2.27,3.77,3.77,0,0,1-1.27-2.64,6.69,6.69,0,0,1,.1-2.23c-.75.05-1.49.88-2.2,2.47a7.86,7.86,0,0,0-.84,4.17C131.77,252.24,132.21,252.74,133,252.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.61,243.06a1.07,1.07,0,0,1,.79.09.6.6,0,0,1,.33.62,26.25,26.25,0,0,1-3.57,5.42c-1.28,1.47-2.45,2.27-3.5,2.41a1.78,1.78,0,0,1-1.42-.36,2.22,2.22,0,0,1-.69-1.48q-.3-2.35,1.9-7.14l-.12,0a29.66,29.66,0,0,0-5.39,8.61c-1.56.49-2.41,0-2.54-1.54a16.7,16.7,0,0,1,.88-5.47l-.07-.08a35.64,35.64,0,0,0-2.73,4.71,28,28,0,0,0-2,4.79,2.18,2.18,0,0,1-2,.13,2.08,2.08,0,0,1-1.23-1.82,11.62,11.62,0,0,1,.36-3.71,19.25,19.25,0,0,1,1.49-4.3c.63-1.29,1.24-2,1.81-2A2.24,2.24,0,0,1,145,242a1.7,1.7,0,0,1,.86.63,15.32,15.32,0,0,0-1.48,3.25,15.14,15.14,0,0,0-.92,4.13,52,52,0,0,1,3.51-6.22q2-3,2.94-3.1a1.89,1.89,0,0,1,1.19.22,1.56,1.56,0,0,1,.75.78,12.13,12.13,0,0,0-1,2.69c-.37,1.34-.65,2.52-.83,3.54a47.62,47.62,0,0,1,3.51-5.37q1.93-2.58,2.94-2.7a2.67,2.67,0,0,1,1.54.27,1.7,1.7,0,0,1,1,1,16.17,16.17,0,0,0-1.43,3.33,7.54,7.54,0,0,0-.47,3.14c.06.46.22.67.47.64.42-.05,1-.58,1.75-1.57A27,27,0,0,0,161.61,243.06Z",
    fill: "#fff"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42,278.67l.33.24a9.86,9.86,0,0,1-2.86,1.67,9.63,9.63,0,0,1-9.94-2,9,9,0,0,1-2-2.87,8.4,8.4,0,0,1-.75-3.5A8.55,8.55,0,0,1,28,267.64a9,9,0,0,1,3.39-3.28,9.43,9.43,0,0,1,4.68-1.2A9.31,9.31,0,0,1,41.82,265l-.21.32a9,9,0,0,0-5.5-1.81,9.18,9.18,0,0,0-6.32,2.52,8.58,8.58,0,0,0-1.91,2.76,8.33,8.33,0,0,0,.49,7.67,8.72,8.72,0,0,0,3.25,3.13,9,9,0,0,0,4.49,1.16,9.18,9.18,0,0,0,3.18-.56A8.45,8.45,0,0,0,42,278.67Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.88,272a8.94,8.94,0,0,1-.74,3.59,9.18,9.18,0,0,1-2,2.93,9.53,9.53,0,0,1-6.59,2.66,9.26,9.26,0,0,1-3.6-.72,9.69,9.69,0,0,1-3-1.93,9,9,0,0,1-2-2.89,8.58,8.58,0,0,1-.75-3.53,8.45,8.45,0,0,1,.75-3.51,9,9,0,0,1,2-2.89,9.68,9.68,0,0,1,3-1.94,9.55,9.55,0,0,1,3.66-.72,9.42,9.42,0,0,1,3.57.69,9.29,9.29,0,0,1,2.94,1.87,9,9,0,0,1,2,2.85A8.74,8.74,0,0,1,61.88,272Zm-.38.11a8.29,8.29,0,0,0-1.2-4.35,8.65,8.65,0,0,0-3.25-3.16,9,9,0,0,0-4.5-1.16,8.92,8.92,0,0,0-4.48,1.17,8.75,8.75,0,0,0-3.26,3.16,8.36,8.36,0,0,0-1.19,4.34,8.16,8.16,0,0,0,.71,3.37,8.64,8.64,0,0,0,1.9,2.78A9.15,9.15,0,0,0,56,280.13a8.8,8.8,0,0,0,2.85-1.86,8.7,8.7,0,0,0,1.9-2.77A8.16,8.16,0,0,0,61.5,272.13Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M70,280.36v.35H64.17a.22.22,0,0,1-.14-.06.19.19,0,0,1-.07-.13V263.6h.4v16.76Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89,272a8.94,8.94,0,0,1-.74,3.59,9.32,9.32,0,0,1-2,2.93,9.54,9.54,0,0,1-3,1.94,9.41,9.41,0,0,1-7.22,0,9.69,9.69,0,0,1-3-1.93,9,9,0,0,1-2-2.89,8.58,8.58,0,0,1-.75-3.53,8.45,8.45,0,0,1,.75-3.51,8.83,8.83,0,0,1,2-2.89,9.67,9.67,0,0,1,6.66-2.66,9.54,9.54,0,0,1,6.51,2.56,9,9,0,0,1,2,2.85A8.74,8.74,0,0,1,89,272Zm-.38.11a8.37,8.37,0,0,0-1.19-4.35,8.75,8.75,0,0,0-3.26-3.16,9,9,0,0,0-4.5-1.16,8.92,8.92,0,0,0-4.48,1.17,8.65,8.65,0,0,0-3.25,3.16,8.28,8.28,0,0,0-1.2,4.34,8.16,8.16,0,0,0,.71,3.37,8.64,8.64,0,0,0,1.9,2.78,9.15,9.15,0,0,0,9.81,1.85A8.8,8.8,0,0,0,86,278.27a8.7,8.7,0,0,0,1.9-2.77A8.16,8.16,0,0,0,88.57,272.13Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93,272.46H91.67l6.65,8.15-.32.27-6.57-8.08v7.91H91V263.79a.18.18,0,0,1,.06-.13.2.2,0,0,1,.15-.06H93a4.4,4.4,0,0,1,3.15,1.25,4.14,4.14,0,0,1,1.3,3.08V268A4.47,4.47,0,0,1,93,272.46Zm4-4.44v-.09a3.72,3.72,0,0,0-1.18-2.8A4,4,0,0,0,93,264h-1.6v8.07H93a4.08,4.08,0,0,0,4-4.05Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M116.78,263.58v17.13h-.37l-9.35-16.45v16.45h-.35V263.56h.35L116.41,280v-16.4Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M123.65,263.1h.17l5.35,17.63h-.4l-2.48-8.14h-5l-2.37,8.14h-.42Zm.06,1.09-2.35,8h4.81Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M132.2,263.6v17.11h-.38V263.6Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.05,280.36v.35h-5.87a.19.19,0,0,1-.13-.06.16.16,0,0,1-.07-.13V263.6h.4v16.76Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M156.9,267.93V268a4.47,4.47,0,0,1-4.44,4.44h-1.6v8.25h-.4V263.79a.18.18,0,0,1,.06-.13.2.2,0,0,1,.14-.06h1.8a4.36,4.36,0,0,1,3.14,1.25A4.1,4.1,0,0,1,156.9,267.93Zm-.39.09v-.09a3.73,3.73,0,0,0-1.19-2.8,4,4,0,0,0-2.86-1.13h-1.6v8.07h1.6a4.1,4.1,0,0,0,4-4.05Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M176.77,272a8.94,8.94,0,0,1-.74,3.59,9.18,9.18,0,0,1-2,2.93,9.53,9.53,0,0,1-6.59,2.66,9.26,9.26,0,0,1-3.6-.72,9.69,9.69,0,0,1-3-1.93,9.14,9.14,0,0,1-2-2.89,8.73,8.73,0,0,1-.74-3.53,8.6,8.6,0,0,1,.74-3.51,9.14,9.14,0,0,1,2-2.89,9.72,9.72,0,0,1,6.67-2.66,9.36,9.36,0,0,1,3.56.69,9.22,9.22,0,0,1,2.95,1.87,9,9,0,0,1,2,2.85A8.74,8.74,0,0,1,176.77,272Zm-.38.11a8.29,8.29,0,0,0-1.2-4.35,8.72,8.72,0,0,0-3.25-3.16,9,9,0,0,0-4.5-1.16,8.89,8.89,0,0,0-4.48,1.17,8.75,8.75,0,0,0-3.26,3.16,8.41,8.41,0,0,0-.49,7.71,8.82,8.82,0,0,0,1.91,2.78,9.14,9.14,0,0,0,12.66,0,8.87,8.87,0,0,0,1.9-2.77A8.32,8.32,0,0,0,176.39,272.13Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M184.92,280.36v.35h-5.87a.22.22,0,0,1-.13-.06.16.16,0,0,1-.07-.13V263.6h.4v16.76Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M188.41,263.6v17.11H188V263.6Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M200.78,276.66a4.26,4.26,0,0,1-.65,2.29,4.48,4.48,0,0,1-1.7,1.62,4.62,4.62,0,0,1-2.27.58,5.16,5.16,0,0,1-2.88-.77,4.94,4.94,0,0,1-1.84-2.29l.33-.19a5.43,5.43,0,0,0,1.75,2.16,4.59,4.59,0,0,0,2.64.72,4.19,4.19,0,0,0,3-1.19,3.84,3.84,0,0,0,1.26-2.91,3.76,3.76,0,0,0-.35-1.59,4.28,4.28,0,0,0-.94-1.3,7.91,7.91,0,0,0-1.28-1,10.75,10.75,0,0,0-1.48-.74c-.4-.17-.72-.3-1-.41a8.55,8.55,0,0,1-.87-.43,6,6,0,0,1-.83-.5,7.87,7.87,0,0,1-.67-.59,2.94,2.94,0,0,1-.55-.72,4.39,4.39,0,0,1-.33-.87,4.57,4.57,0,0,1,1.06-4.16,4,4,0,0,1,3-1.21,5.37,5.37,0,0,1,2.14.45,3.38,3.38,0,0,1,1.57,1.26l-.26.25a4.26,4.26,0,0,0-3.32-1.56,3.8,3.8,0,0,0-2.81,1.11,3.71,3.71,0,0,0-1.1,2.76,3.32,3.32,0,0,0,.13,1,3.92,3.92,0,0,0,.31.8,2.93,2.93,0,0,0,.52.68,5.92,5.92,0,0,0,.64.55,6.84,6.84,0,0,0,.78.48l.81.4.87.37a10.73,10.73,0,0,1,1.59.8,9.07,9.07,0,0,1,1.37,1.05,4.65,4.65,0,0,1,1,1.41A4.1,4.1,0,0,1,200.78,276.66Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M212.8,263.6v17.11h-.37v-8.25h-9v8.25h-.4V263.6h.4V272h9V263.6Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338,83.48a2,2,0,0,1,1.15,1.46,1.72,1.72,0,0,1-.61,1.54,3.39,3.39,0,0,1-1.92.83,6.53,6.53,0,0,1-.78,0,6.71,6.71,0,0,1-1,0L334,87.2,332.93,87c-.5-.08-.85-.13-1-.14a31.35,31.35,0,0,0-4,8c1.81-.48,2.75-.74,2.8-.76s.33-.14.72-.33.74-.34,1.06-.47a3.6,3.6,0,0,1,.87-.24,2,2,0,0,1,1.1.18,15.76,15.76,0,0,0-1,2.59,16.25,16.25,0,0,0-.6,2.76.87.87,0,0,1-1-.18,2.22,2.22,0,0,1-.53-1.26,4.37,4.37,0,0,1,0-1c-.35,0-.85.07-1.5.16-1.25.15-2.09.27-2.53.35q-2,6.07-1.59,8.85a4.2,4.2,0,0,1-1.22.31,3,3,0,0,1-2.11-.39,2.23,2.23,0,0,1-1-1.65,13.72,13.72,0,0,1,1-5.44,43.71,43.71,0,0,1,3.2-7.17,14.57,14.57,0,0,1,3.42-4.56,12,12,0,0,0-2.15.1A9.06,9.06,0,0,0,323.19,88a6.7,6.7,0,0,0-2.36,2.38,9.6,9.6,0,0,0-1.05,2.75,7.72,7.72,0,0,0-.13,2.65,3.67,3.67,0,0,0,.83,2.14,4.3,4.3,0,0,1-1.13.32,3.41,3.41,0,0,1-2.56-.57,3.51,3.51,0,0,1-1.26-2.54q-.42-3.36,2.59-6.29a14,14,0,0,1,8.28-3.6c.75-.1,2.14-.19,4.16-.27a44.65,44.65,0,0,0,5-.42A4,4,0,0,0,338,83.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,93.43a1,1,0,0,1,.78.09.6.6,0,0,1,.33.61,26.48,26.48,0,0,1-4.06,5.9,7.67,7.67,0,0,1-4.4,2.75,2.86,2.86,0,0,1-2.22-.58,3.32,3.32,0,0,1-1.16-2.35,15.67,15.67,0,0,1,.87-6.42,26.1,26.1,0,0,1,3.33-7q2.13-3.14,4.15-3.39a2.1,2.1,0,0,1,1.52.35,1.8,1.8,0,0,1,.76,1.32q.3,2.27-2.06,6.39a27.3,27.3,0,0,1-5.29,6.76l0,.24a2.67,2.67,0,0,0,.56,1.46,1.22,1.22,0,0,0,1.11.43,5.07,5.07,0,0,0,2.77-2A24,24,0,0,0,346.66,93.43Zm-2.47-8.11c-.58.07-1.44,1.34-2.6,3.8a26,26,0,0,0-2.25,6.76A26.14,26.14,0,0,0,343,90.51q1.77-3.36,1.6-4.65Q344.48,85.29,344.19,85.32Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.18,92.09a1,1,0,0,1,.79.09.6.6,0,0,1,.33.61q-4.41,8.13-9.06,8.73a3.81,3.81,0,0,1-2.85-.62,3.52,3.52,0,0,1-1.32-2.51,8.57,8.57,0,0,1,.51-3.86,11.3,11.3,0,0,1,2.23-3.88A5.11,5.11,0,0,1,351,88.73a3.58,3.58,0,0,1,2.35.46,2.19,2.19,0,0,1,1.19,1.63c.12.94-.38,2.08-1.49,3.43a14,14,0,0,1-4.45,3.46,1.54,1.54,0,0,0,1.85,1.14,6.39,6.39,0,0,0,3.67-2.34A18.74,18.74,0,0,0,357.18,92.09Zm-5.77-2c-.52.07-1.13.85-1.85,2.34a10.25,10.25,0,0,0-1.14,4,11.47,11.47,0,0,0,2.68-2.92,4.5,4.5,0,0,0,.95-2.78C352,90.3,351.77,90.09,351.41,90.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.82,90.35a1,1,0,0,1,.79.09.58.58,0,0,1,.32.61q-4,7.44-6.49,7.76a1.79,1.79,0,0,1-1.66-.65,3.43,3.43,0,0,1-.83-1.93,2.1,2.1,0,0,1,0-.46q-2.87,4.45-4.78,4.7a2,2,0,0,1-1.54-.48,2.75,2.75,0,0,1-.94-1.95,10.19,10.19,0,0,1,.42-3.94,12.49,12.49,0,0,1,2-4.16,4.63,4.63,0,0,1,3.06-2.1,2.94,2.94,0,0,1,1.8.32,2.8,2.8,0,0,1,1.26,1.42q1-2.2,2.1-2.34a1.85,1.85,0,0,1,1.25.26,1.79,1.79,0,0,1,.72.74,8.4,8.4,0,0,1-.69,1.69A22.25,22.25,0,0,1,366.44,92a9.6,9.6,0,0,0-.16,2.65c.09.69.29,1,.62,1C367.59,95.53,368.9,93.77,370.82,90.35Zm-11.1,6.76c.31,0,.82-.52,1.53-1.45a25.38,25.38,0,0,0,2.08-3.27,13.62,13.62,0,0,1,.44-1.61c-.52-.75-1-1.1-1.53-1s-1.07.53-1.58,1.38a10.69,10.69,0,0,0-1.17,2.8,6.57,6.57,0,0,0-.27,2.4C359.29,96.89,359.46,97.15,359.72,97.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.79,94.55q2.68,3,5.66,2.67a3,3,0,0,1-.94,1.71,3.62,3.62,0,0,1-2.27,1.09q-3.25.42-5.86-3.11a13.21,13.21,0,0,1-4.72,1.71,5.92,5.92,0,0,1-3.94-.59,3.64,3.64,0,0,1-1.7-2.78A5.26,5.26,0,0,1,379.44,91a19.52,19.52,0,0,1,5.06-3.92,18,18,0,0,1-.32-2.48,6.51,6.51,0,0,1,1.32-4.67,5.65,5.65,0,0,1,3.78-2.15,4.84,4.84,0,0,1,2.92.45,2.57,2.57,0,0,1,1.41,2.1,3.57,3.57,0,0,1-.33,1.83,5.65,5.65,0,0,1-1.3,1.74,15.64,15.64,0,0,1-1.86,1.52c-.66.46-1.43.95-2.32,1.47a20.5,20.5,0,0,0,2.7,6,17,17,0,0,0,3-3.93,6.53,6.53,0,0,0,1.08-3.13,2.51,2.51,0,0,1,1.63.16,1.41,1.41,0,0,1,.79,1.16c.11.85-.34,2-1.33,3.35A22.14,22.14,0,0,1,391.79,94.55ZM385,95.85a8,8,0,0,0,2.25-.64,24.27,24.27,0,0,1-2.42-6.42q-3.45,2.55-3.12,5.11C381.93,95.4,383,96,385,95.85Zm2-12.92c.07.72.19,1.5.35,2.35,2.43-1.65,3.54-3.21,3.35-4.69a1.66,1.66,0,0,0-.5-1.08,1.26,1.26,0,0,0-1-.28,2.32,2.32,0,0,0-1.71,1.16A3.85,3.85,0,0,0,387,82.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.07,73.11a1.9,1.9,0,0,1,.71,1.06,1.28,1.28,0,0,1-.46,1.24,3.46,3.46,0,0,1-2.05.79,15.88,15.88,0,0,1-4-.31A36.11,36.11,0,0,0,416,85.27q-2,6.14-1.62,9a4.7,4.7,0,0,1-1.22.3,3,3,0,0,1-2.11-.39,2.21,2.21,0,0,1-1-1.65,13.26,13.26,0,0,1,1-5.22,43.28,43.28,0,0,1,3.06-7,18,18,0,0,1,3.38-4.74,15.27,15.27,0,0,0-3.12,0,7.77,7.77,0,0,0-5,2.48,5.54,5.54,0,0,0-1.55,4.58,4.39,4.39,0,0,0,1.29,2.82,4.51,4.51,0,0,1-3.52,0,3.27,3.27,0,0,1-1.81-2.81,6.13,6.13,0,0,1,2.29-5.49,12.9,12.9,0,0,1,7.3-3A44.53,44.53,0,0,1,419,74a45.58,45.58,0,0,0,4.63-.06A4.9,4.9,0,0,0,426.07,73.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.71,84a31.88,31.88,0,0,1-3.46,5.75C423.08,91.18,422,92,421,92.11a2.24,2.24,0,0,1-1.6-.44,2.42,2.42,0,0,1-.93-1.81,10.45,10.45,0,0,1,.4-3.71,18.77,18.77,0,0,1,1.57-4.2c.66-1.25,1.28-1.92,1.85-2a2.21,2.21,0,0,1,1.22.15,1.63,1.63,0,0,1,.75.62,15.86,15.86,0,0,0-1.56,3.46,9.07,9.07,0,0,0-.69,3.9c.07.56.27.82.6.77q1.17-.15,4-5.62a1.08,1.08,0,0,1,.79.09A.59.59,0,0,1,427.71,84Zm-3-5.58a1.45,1.45,0,0,1-1.16-.29,1.63,1.63,0,0,1-.63-1.18,3.89,3.89,0,0,1,.35-2,1.74,1.74,0,0,1,1.31-1.19,2.2,2.2,0,0,1,1.6.41c.5.35.76.66.8,1a4.21,4.21,0,0,0-1.22,1.36A9.84,9.84,0,0,0,424.69,78.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,82.64a23.07,23.07,0,0,1-4.3,6.16A8.32,8.32,0,0,1,429,91.35a3.5,3.5,0,0,1-2.71-.66A3.61,3.61,0,0,1,425,88.18a8.57,8.57,0,0,1,.51-3.86,11.42,11.42,0,0,1,2.2-3.87,5.06,5.06,0,0,1,3.11-1.9,4.33,4.33,0,0,1,2.35.38,2,2,0,0,1,1.32,1.58,3.37,3.37,0,0,1-1.14,2.69c-.86.93-1.66,1.31-2.38,1.15a8.93,8.93,0,0,0,.89-3.82c-.06-.42-.24-.62-.54-.58s-.74.45-1.22,1.22A11.71,11.71,0,0,0,428.86,84a7.15,7.15,0,0,0-.36,2.91c.16,1.25.78,1.8,1.85,1.66a6,6,0,0,0,3.54-2.25,19.12,19.12,0,0,0,3-4.39,1,1,0,0,1,.79.09A.58.58,0,0,1,438,82.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.82,80.29a1,1,0,0,1,.78.09.6.6,0,0,1,.33.61q-3.71,7.41-6.61,7.77a2.26,2.26,0,0,1-2.25-1.09,5.06,5.06,0,0,1-.79-3.23A21.38,21.38,0,0,0,438.36,90a2.25,2.25,0,0,1-.59.13,2.17,2.17,0,0,1-2.5-2c-.16-1.19.2-3.16,1.06-5.91a43.22,43.22,0,0,1,3.22-7.72q1.93-3.59,3.32-3.77a2.6,2.6,0,0,1,1.3.19,1.79,1.79,0,0,1,.88.62,26.61,26.61,0,0,0-4.22,7.3,37.38,37.38,0,0,0-2.43,7.72,42,42,0,0,1,4-6.27q2.26-3,3.67-3.17a1.41,1.41,0,0,1,1.07.3,1.34,1.34,0,0,1,.55.92,7.33,7.33,0,0,1-1.52,1.26,26.8,26.8,0,0,1-2.36,1.52,4.54,4.54,0,0,0,0,2.2,4.31,4.31,0,0,0,.88,1.72,1.37,1.37,0,0,0,1.15.61Q447,85.53,449.82,80.29Z",
    fill: "#fff"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M332.94,108.37v.08a4.47,4.47,0,0,1-4.45,4.45h-1.6v8.25h-.4V104.23a.18.18,0,0,1,.06-.13.2.2,0,0,1,.15-.06h1.79a4.4,4.4,0,0,1,3.15,1.25A4.1,4.1,0,0,1,332.94,108.37Zm-.4.08v-.08a3.72,3.72,0,0,0-1.18-2.8,4,4,0,0,0-2.87-1.13h-1.6v8.06h1.6a4.06,4.06,0,0,0,4.05-4Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M336.89,112.9h-1.36l6.65,8.14-.31.28-6.58-8.09v7.92h-.39V104.23a.17.17,0,0,1,.05-.13.2.2,0,0,1,.15-.06h1.79a4.4,4.4,0,0,1,3.15,1.25,4.1,4.1,0,0,1,1.3,3.08v.08a4.47,4.47,0,0,1-4.45,4.45Zm4.05-4.45v-.08a3.72,3.72,0,0,0-1.18-2.8,4,4,0,0,0-2.87-1.13h-1.6v8.06h1.6a4.06,4.06,0,0,0,4.05-4Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M351,120.78v.39h-6.71V104h6.57v.4h-6.16v7.87h6.16v.42h-6.16v8Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M363.24,104h.4l-5.22,17.64h-.15L352.92,104h.38l5.06,16.58Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M372.28,120.78v.39h-6.72V104h6.58v.4H366v7.87h6.16v.42H366v8Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M385.14,104v17.13h-.38l-9.35-16.46v16.46h-.35V104h.35l9.35,16.42V104Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M395.7,104v.4h-3.95v16.71h-.38V104.44h-4V104Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M400.47,103.53h.17L406,121.17h-.4L403.11,113h-5l-2.37,8.14h-.42Zm.06,1.1-2.35,8H403Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M413.86,104v.4h-3.94v16.71h-.39V104.44h-4V104Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M417.48,104v17.11h-.37V104Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M430.7,104h.4l-5.22,17.64h-.15L420.38,104h.38l5.06,16.58Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M439.74,120.78v.39H433V104h6.57v.4h-6.16v7.87h6.16v.42h-6.16v8Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.76,159.27a8,8,0,0,1,5.35.89,5.49,5.49,0,0,1,2.47,4.26,13.28,13.28,0,0,1-1.05,6.75,17.1,17.1,0,0,1-4.28,6.16,10.79,10.79,0,0,1-6,3,5.41,5.41,0,0,1-3.81-.71,4.1,4.1,0,0,1-1.76-3.08,7.31,7.31,0,0,1,.11-2.3,3.76,3.76,0,0,1-2.06-1,3.32,3.32,0,0,1-1.05-2.15,6.62,6.62,0,0,1,.67-3.55,13.81,13.81,0,0,1,2.49-3.66,15.51,15.51,0,0,1,4-3A14,14,0,0,1,349.76,159.27Zm-2.66,18.61a5.9,5.9,0,0,0,3.64-2.43,15.71,15.71,0,0,0,2.77-5.34,13.76,13.76,0,0,0,.63-5.84q-.5-3.95-4.07-3.49a9.61,9.61,0,0,0-6.2,3.91c-1.86,2.31-2.66,4.59-2.37,6.83l0,.32a15.55,15.55,0,0,1,3.11-4.64,6.75,6.75,0,0,1,3.82-2.24c1-.12,1.64.15,1.92.84A10.38,10.38,0,0,0,346,170a8.8,8.8,0,0,0-1.45,5.58,2.76,2.76,0,0,0,.85,1.85A2.08,2.08,0,0,0,347.1,177.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.73,167.52a1,1,0,0,1,.78.09.6.6,0,0,1,.33.61,30.06,30.06,0,0,1-3.71,5.86c-1.39,1.69-2.66,2.61-3.79,2.76a2.14,2.14,0,0,1-1.65-.45,2.24,2.24,0,0,1-.85-1.54,9.09,9.09,0,0,1,1-3.87,9.82,9.82,0,0,0,1-3.49c-.05-.42-.38-.75-1-1l-1.45,3.05a1.22,1.22,0,0,1-.74-.14.65.65,0,0,1-.38-.56,19.83,19.83,0,0,0,1.19-2.87,1.32,1.32,0,0,1-.83-1,2,2,0,0,1,.56-1.59,2.39,2.39,0,0,1,1.56-.87.81.81,0,0,1,1,.78,3.43,3.43,0,0,1-.25,1.69,1.15,1.15,0,0,0,.31.18l.47.21.5.24c1.39.72,2.13,1.36,2.2,1.94a7.35,7.35,0,0,1-.69,2.75,7.78,7.78,0,0,0-.69,2.72q.09.63.51.57c.43-.05,1.1-.71,2-2A31.78,31.78,0,0,0,369.73,167.52Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.36,165.78a1.07,1.07,0,0,1,.79.09.6.6,0,0,1,.33.62,22.19,22.19,0,0,1-2.89,4.43,25,25,0,0,1-3.44,3.3,22.62,22.62,0,0,1-2.73,6.36,5.62,5.62,0,0,1-4,2.82,3.44,3.44,0,0,1-2.31-.43,2.34,2.34,0,0,1-1.13-1.76,2.82,2.82,0,0,1,0-.77,2,2,0,0,1,.26-.75c.15-.26.29-.48.44-.69a4.43,4.43,0,0,1,.69-.7c.31-.26.58-.49.82-.67s.57-.43,1-.73.8-.55,1.11-.74l1.27-.82,1.32-.86c.24-1,.46-2.27.67-3.68A20.46,20.46,0,0,1,373,174a4.47,4.47,0,0,1-2.35,1.46,2.22,2.22,0,0,1-1.58-.46,2.34,2.34,0,0,1-.92-1.71,9.24,9.24,0,0,1,.49-3.83,13,13,0,0,1,2.12-4.12,4.76,4.76,0,0,1,3.07-2.07,2.76,2.76,0,0,1,1.72.31,2.81,2.81,0,0,1,1.24,1.36c.62-1.41,1.33-2.16,2.14-2.26a1.81,1.81,0,0,1,1.25.29,2.06,2.06,0,0,1,.75.71,12.79,12.79,0,0,1-1.46,3.05,42.27,42.27,0,0,1-.77,5.16A22.21,22.21,0,0,0,383.36,165.78Zm-12.2,15.73c.57-.07,1.14-.56,1.71-1.46a14.71,14.71,0,0,0,1.53-3.6c-2.91,1.93-4.3,3.41-4.17,4.42a.69.69,0,0,0,.33.52A.91.91,0,0,0,371.16,181.51Zm1-9c.32,0,.85-.52,1.57-1.44a26,26,0,0,0,2.13-3.24c.14-.6.29-1.14.44-1.61-.55-.78-1.07-1.15-1.57-1.08-.85.11-1.62,1.07-2.32,2.89a8.31,8.31,0,0,0-.71,3.84C371.81,172.37,372,172.58,372.21,172.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,164a1,1,0,0,1,.78.09.6.6,0,0,1,.33.62q-4,7.42-6.5,7.76a1.81,1.81,0,0,1-1.66-.66,3.51,3.51,0,0,1-.83-1.92c0-.21,0-.37,0-.47-1.9,3-3.49,4.54-4.78,4.71a2.1,2.1,0,0,1-1.53-.48,2.77,2.77,0,0,1-.94-2,10.21,10.21,0,0,1,.42-3.94,12.68,12.68,0,0,1,2-4.16,4.63,4.63,0,0,1,3.06-2.1,3,3,0,0,1,1.8.33,2.76,2.76,0,0,1,1.26,1.42c.69-1.48,1.39-2.26,2.1-2.35a1.82,1.82,0,0,1,1.25.27,1.73,1.73,0,0,1,.72.74,8.79,8.79,0,0,1-.69,1.68,19.9,19.9,0,0,1-1.17,2.06,9.23,9.23,0,0,0-.16,2.65c.09.7.29,1,.62,1C393.77,169.22,395.08,167.47,397,164Zm-11.1,6.77c.31,0,.82-.53,1.53-1.45a25.54,25.54,0,0,0,2.08-3.28,14.16,14.16,0,0,1,.44-1.61c-.53-.75-1-1.09-1.54-1s-1.06.53-1.57,1.39a10.17,10.17,0,0,0-1.17,2.79,6.89,6.89,0,0,0-.28,2.4C385.47,170.58,385.63,170.84,385.9,170.81Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.89,162.27a1.07,1.07,0,0,1,.79.09.61.61,0,0,1,.33.62,26.77,26.77,0,0,1-3.55,5.42c-1.28,1.47-2.45,2.27-3.52,2.41a1.75,1.75,0,0,1-1.4-.36,2.22,2.22,0,0,1-.68-1.48c-.18-1.38.48-3.67,2-6.86l-.1-.07a19.29,19.29,0,0,0-3.32,4.51,23.81,23.81,0,0,0-2.71,5.52,2.18,2.18,0,0,1-2,.13,2.07,2.07,0,0,1-1.22-1.82,11.06,11.06,0,0,1,.36-3.71,19.24,19.24,0,0,1,1.48-4.3c.64-1.29,1.24-2,1.82-2a2.22,2.22,0,0,1,1.14.16,1.66,1.66,0,0,1,.86.63,16.2,16.2,0,0,0-1.47,3.25,14.78,14.78,0,0,0-.92,4.13,49.73,49.73,0,0,1,3.86-6.15q2.3-3.14,3.33-3.27a2.4,2.4,0,0,1,1.45.3,1.8,1.8,0,0,1,.94,1,16.79,16.79,0,0,0-1.4,3.37,8.05,8.05,0,0,0-.5,3.1c.06.46.22.68.47.64.44-.05,1-.58,1.78-1.57A25.22,25.22,0,0,0,410.89,162.27Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.56,162.14a31.53,31.53,0,0,1-3.46,5.75c-1.16,1.48-2.24,2.29-3.21,2.41a2.2,2.2,0,0,1-1.61-.44,2.47,2.47,0,0,1-.93-1.81,10.63,10.63,0,0,1,.4-3.7,19,19,0,0,1,1.57-4.21c.66-1.25,1.28-1.91,1.85-2a2.3,2.3,0,0,1,1.22.16,1.52,1.52,0,0,1,.75.62,15.72,15.72,0,0,0-1.56,3.45,8.94,8.94,0,0,0-.68,3.91c.07.55.26.81.59.77q1.18-.15,4-5.62a1,1,0,0,1,.79.09A.58.58,0,0,1,418.56,162.14Zm-3-5.57a1.49,1.49,0,0,1-1.16-.29,1.7,1.7,0,0,1-.63-1.18,3.84,3.84,0,0,1,.36-2,1.74,1.74,0,0,1,1.3-1.19,2.28,2.28,0,0,1,1.61.41c.49.35.75.67.79,1a4.15,4.15,0,0,0-1.22,1.35A9.89,9.89,0,0,0,415.54,156.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.84,160.84a23.42,23.42,0,0,1-4.31,6.16,8.32,8.32,0,0,1-4.64,2.55,3.51,3.51,0,0,1-2.7-.67,3.56,3.56,0,0,1-1.33-2.5,8.77,8.77,0,0,1,.51-3.87,11.64,11.64,0,0,1,2.2-3.86,5,5,0,0,1,3.11-1.9,4.37,4.37,0,0,1,2.36.37,2,2,0,0,1,1.31,1.59,3.38,3.38,0,0,1-1.14,2.69c-.86.92-1.66,1.31-2.38,1.15a8.82,8.82,0,0,0,.89-3.83q-.09-.63-.54-.57c-.33,0-.73.45-1.22,1.22a12,12,0,0,0-1.25,2.83,7.19,7.19,0,0,0-.36,2.91c.16,1.25.78,1.8,1.85,1.67a6.08,6.08,0,0,0,3.54-2.25,18.86,18.86,0,0,0,3-4.4,1,1,0,0,1,.79.09A.6.6,0,0,1,428.84,160.84Z",
    fill: "#fff"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M305.84,189.49a8.94,8.94,0,0,1-.74,3.59,9.18,9.18,0,0,1-2,2.93,9.38,9.38,0,0,1-3,1.94,9.53,9.53,0,0,1-7.22,0,9.69,9.69,0,0,1-3-1.93,9.14,9.14,0,0,1-2-2.89,8.73,8.73,0,0,1-.74-3.53,8.6,8.6,0,0,1,.74-3.51,9.14,9.14,0,0,1,2-2.89,9.68,9.68,0,0,1,3-1.94,9.52,9.52,0,0,1,3.66-.72,9.42,9.42,0,0,1,3.57.69,9.29,9.29,0,0,1,2.94,1.87,9,9,0,0,1,2,2.85A8.71,8.71,0,0,1,305.84,189.49Zm-.38.11a8.29,8.29,0,0,0-1.2-4.35,8.72,8.72,0,0,0-3.25-3.16,9,9,0,0,0-4.5-1.16A8.89,8.89,0,0,0,292,182.1a8.75,8.75,0,0,0-3.26,3.16,8.49,8.49,0,0,0-.49,7.71,8.82,8.82,0,0,0,1.91,2.78A9.15,9.15,0,0,0,300,197.6a9.14,9.14,0,0,0,2.85-1.86,8.7,8.7,0,0,0,1.9-2.77A8.16,8.16,0,0,0,305.46,189.6Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M311.55,180.56h.17l5.35,17.64h-.39l-2.48-8.14h-5l-2.38,8.14h-.42Zm.07,1.1-2.36,8h4.82Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M325,181.07v.4H321v16.71h-.39V181.47h-4v-.4Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M341.06,180.78l3.46,17.42h-.38l-3.34-16.69-5.17,12.62h-.35l-5.57-12.62-2.8,16.69h-.38l2.92-17.4h.37l5.63,12.74,5.24-12.76Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M353.34,197.81v.39h-6.71V181.07h6.57v.4H347v7.87h6.16v.42H347v8.05Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M360.19,180.56h.17l5.35,17.64h-.39l-2.48-8.14h-5l-2.38,8.14H355Zm.07,1.1-2.36,8h4.82Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M373.47,197.83v.35h-5.86a.22.22,0,0,1-.14-.06.16.16,0,0,1-.07-.13V181.07h.4v16.76Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M383.85,181l.33.16-8.75,17.62-.34-.15Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M388.83,180.56H389l5.35,17.64H394l-2.49-8.14h-5l-2.38,8.14h-.42Zm.07,1.1-2.36,8h4.82Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M402.11,197.83v.35h-5.87a.22.22,0,0,1-.13-.06A.16.16,0,0,1,396,198V181.07h.4v16.76Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M421,189.49a8.79,8.79,0,0,1-.75,3.59,9,9,0,0,1-2,2.93,9.38,9.38,0,0,1-3,1.94,9.55,9.55,0,0,1-10.2-1.93,9.14,9.14,0,0,1-2-2.89,8.57,8.57,0,0,1-.74-3.53,8.44,8.44,0,0,1,.74-3.51,9.14,9.14,0,0,1,2-2.89,9.72,9.72,0,0,1,6.67-2.66,9.36,9.36,0,0,1,3.56.69,9.22,9.22,0,0,1,2.95,1.87,8.78,8.78,0,0,1,2,2.85A8.55,8.55,0,0,1,421,189.49Zm-.38.11a8.29,8.29,0,0,0-1.2-4.35,8.72,8.72,0,0,0-3.25-3.16,9,9,0,0,0-4.5-1.16,8.89,8.89,0,0,0-4.48,1.17,8.75,8.75,0,0,0-3.26,3.16,8.41,8.41,0,0,0-.49,7.71,8.82,8.82,0,0,0,1.91,2.78,9.15,9.15,0,0,0,9.81,1.85,9.37,9.37,0,0,0,2.85-1.86,8.87,8.87,0,0,0,1.9-2.77A8.32,8.32,0,0,0,420.65,189.6Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M429.82,197.81v.39h-6.71V181.07h6.57v.4h-6.15v7.87h6.15v.42h-6.15v8.05Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M446.79,193.67a4.65,4.65,0,0,1-.3,1.66,4.85,4.85,0,0,1-.88,1.44,4,4,0,0,1-1.49,1,5.44,5.44,0,0,1-2.06.38h-3.19V181.07h3.06a4.22,4.22,0,0,1,3,1.17,3.84,3.84,0,0,1,1.25,2.92,4,4,0,0,1-.81,2.47,4.32,4.32,0,0,1-2.11,1.55,4.42,4.42,0,0,1,2.63,1.68A4.63,4.63,0,0,1,446.79,193.67Zm-1-8.53a3.32,3.32,0,0,0-1.22-2.67,4.53,4.53,0,0,0-3.05-1h-2.22v7.62h2.39a4.09,4.09,0,0,0,2.88-1.12A3.62,3.62,0,0,0,445.78,185.14Zm.61,8.53a4.16,4.16,0,0,0-.3-1.56,4.09,4.09,0,0,0-.86-1.34,4,4,0,0,0-1.47-1,5.6,5.6,0,0,0-2.06-.36h-2.41v8.31h2.77a4.69,4.69,0,0,0,1.87-.35,3.65,3.65,0,0,0,1.36-.93,4.35,4.35,0,0,0,.81-1.31A4,4,0,0,0,446.39,193.67Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M452.88,180.56h.17l5.35,17.64H458l-2.48-8.14h-5l-2.37,8.14h-.42Zm.06,1.1-2.35,8h4.81Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M466.27,181.07v.4h-3.94v16.71h-.39V181.47h-4v-.4Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M478.29,181.07v17.11h-.36v-8.25h-9v8.25h-.4V181.07h.4v8.44h9v-8.44Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M407.9,211.16l1.51-7.14H413l-.05.25h-3.32l-.71,3.35h3.14l-.06.25h-3.14l-.69,3.29Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M414.64,211.26a1.67,1.67,0,0,1-1.37-.56,2.27,2.27,0,0,1-.45-1.46,4.11,4.11,0,0,1,.37-1.82,2.91,2.91,0,0,1,1-1.21,2.44,2.44,0,0,1,1.4-.43,1.8,1.8,0,0,1,1,.26,1.73,1.73,0,0,1,.6.71,2.59,2.59,0,0,1,.2,1,4.82,4.82,0,0,1-.18,1.34,3.82,3.82,0,0,1-.54,1.11,2.83,2.83,0,0,1-.86.76A2.41,2.41,0,0,1,414.64,211.26Zm0-.25a2,2,0,0,0,1.31-.43,2.74,2.74,0,0,0,.83-1.17,4.31,4.31,0,0,0,.29-1.64,2,2,0,0,0-.38-1.25,1.4,1.4,0,0,0-1.16-.49,2.12,2.12,0,0,0-1.26.4,2.6,2.6,0,0,0-.88,1.11,4.06,4.06,0,0,0-.33,1.7,1.93,1.93,0,0,0,.4,1.29A1.44,1.44,0,0,0,414.67,211Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M418.24,211.16l1.12-5.28h.22l-.28,1.39h0a5.69,5.69,0,0,1,.44-.63,2.71,2.71,0,0,1,.67-.59,1.53,1.53,0,0,1,.85-.25,2.1,2.1,0,0,1,.59.08l-.06.24-.23-.05-.3,0a1.6,1.6,0,0,0-.92.33,3.16,3.16,0,0,0-.8.89,3.93,3.93,0,0,0-.5,1.23l-.56,2.66Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M424.3,211.16l0-.2.66,0,1.42-6.67-.65,0,0-.2h1.58l0,.2-.67,0-1.42,6.67.66,0,0,.2Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M428.47,211.26a.83.83,0,0,1-1-.92,2.65,2.65,0,0,1,0-.27c0-.1,0-.2,0-.31l.77-3.63h-.77l.05-.22.77,0,.34-1.31H429l-.28,1.31h1.63l-.06.25h-1.63l-.76,3.6c0,.11,0,.21-.05.31s0,.2,0,.28a.78.78,0,0,0,.16.51.69.69,0,0,0,.53.18,2.81,2.81,0,0,0,.43,0,2.75,2.75,0,0,0,.34-.1v.25a1.69,1.69,0,0,1-.34.09A1.83,1.83,0,0,1,428.47,211.26Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M432.57,211.26a2,2,0,0,1-1.05-.27,1.77,1.77,0,0,1-.65-.73,2.45,2.45,0,0,1-.22-1,4.37,4.37,0,0,1,.19-1.31,3.42,3.42,0,0,1,.54-1.1,2.63,2.63,0,0,1,.88-.75,2.46,2.46,0,0,1,1.19-.28,3.71,3.71,0,0,1,.67.06,2.17,2.17,0,0,1,.56.18l-.08.25a1.84,1.84,0,0,0-.56-.18,3.19,3.19,0,0,0-.59-.06,2.17,2.17,0,0,0-1.34.43,2.84,2.84,0,0,0-.88,1.15,4.06,4.06,0,0,0-.31,1.59,2.06,2.06,0,0,0,.19.91,1.54,1.54,0,0,0,.55.66,1.68,1.68,0,0,0,.92.24,2.3,2.3,0,0,0,.66-.08,3,3,0,0,0,.61-.22V211a2.6,2.6,0,0,1-1.28.29Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M434.94,211.16l1.61-7.6h.26l-.43,2c-.06.28-.12.57-.19.86s-.13.56-.2.82h0a4.3,4.3,0,0,1,.49-.66,3.05,3.05,0,0,1,.74-.59,2,2,0,0,1,1-.24,1.39,1.39,0,0,1,1,.33,1.26,1.26,0,0,1,.35,1,2.69,2.69,0,0,1-.08.66l-.72,3.42h-.26l.73-3.45a2.1,2.1,0,0,0,.06-.31,2.72,2.72,0,0,0,0-.28,1,1,0,0,0-.3-.82,1.18,1.18,0,0,0-.83-.27,1.87,1.87,0,0,0-1,.34,3,3,0,0,0-.85.89,3.38,3.38,0,0,0-.49,1.16l-.58,2.74Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M439.58,213.59a1.29,1.29,0,0,1-.57-.1v-.26a1.12,1.12,0,0,0,.26.08,1.55,1.55,0,0,0,.33,0,.93.93,0,0,0,.66-.28,3.62,3.62,0,0,0,.63-.87l.64-1.1-.88-5.21h.26l.59,3.56c.06.31.1.57.13.79a5,5,0,0,1,.07.56h0l.29-.55c.11-.22.26-.47.42-.76l2-3.6h.29l-3.63,6.43a3.77,3.77,0,0,1-.7.95A1.18,1.18,0,0,1,439.58,213.59Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M447.35,211.16l1.51-7.14h1.45a3,3,0,0,1,2.14.72,2.83,2.83,0,0,1,.77,2.17,4.89,4.89,0,0,1-.26,1.58,4.14,4.14,0,0,1-.81,1.37,3.91,3.91,0,0,1-1.38.95,4.87,4.87,0,0,1-2,.35Zm1.47-.25a4.59,4.59,0,0,0,1.8-.32,3.57,3.57,0,0,0,1.29-.88,3.9,3.9,0,0,0,.78-1.28,4.49,4.49,0,0,0,.26-1.52,2.59,2.59,0,0,0-.71-2,3,3,0,0,0-2-.64h-1.13l-1.41,6.64Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M453.94,211.16l1.12-5.28h.22l-.28,1.39h0a5.69,5.69,0,0,1,.44-.63,2.71,2.71,0,0,1,.67-.59,1.53,1.53,0,0,1,.85-.25,2.1,2.1,0,0,1,.59.08l-.06.24-.23-.05-.3,0a1.6,1.6,0,0,0-.92.33,3.16,3.16,0,0,0-.8.89,3.93,3.93,0,0,0-.5,1.23l-.56,2.66Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M456.75,213.59a1.29,1.29,0,0,1-.57-.1v-.26a1.12,1.12,0,0,0,.26.08,1.55,1.55,0,0,0,.33,0,.93.93,0,0,0,.66-.28,3.92,3.92,0,0,0,.63-.87l.64-1.1-.88-5.21h.26l.59,3.56c.05.31.1.57.13.79s.06.41.07.56h0l.29-.55c.11-.22.26-.47.42-.76l2-3.6h.29l-3.63,6.43a4,4,0,0,1-.7.95A1.18,1.18,0,0,1,456.75,213.59Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M466,211.26a4.34,4.34,0,0,1-1.05-.1,5.37,5.37,0,0,1-.74-.24v-.29a3.68,3.68,0,0,0,.79.28,4.34,4.34,0,0,0,1,.1,3,3,0,0,0,.7-.09,2.15,2.15,0,0,0,.68-.29,1.43,1.43,0,0,0,.71-1.31,1.36,1.36,0,0,0-.2-.77,2,2,0,0,0-.54-.54,7.35,7.35,0,0,0-.81-.45,4.76,4.76,0,0,1-.64-.39,2.06,2.06,0,0,1-.51-.55,1.45,1.45,0,0,1-.2-.77,1.93,1.93,0,0,1,.2-.9,1.7,1.7,0,0,1,.54-.59,2.31,2.31,0,0,1,.73-.33,3.21,3.21,0,0,1,.8-.11,4,4,0,0,1,.92.1,4.93,4.93,0,0,1,.73.27l-.11.25a3.25,3.25,0,0,0-.74-.28,3.18,3.18,0,0,0-.81-.09,3,3,0,0,0-.63.08,2.7,2.7,0,0,0-.66.27,1.52,1.52,0,0,0-.5.51,1.57,1.57,0,0,0-.2.81,1.2,1.2,0,0,0,.19.7,1.59,1.59,0,0,0,.47.46,5.08,5.08,0,0,0,.59.35c.31.16.59.33.84.49a2.1,2.1,0,0,1,.59.6,1.62,1.62,0,0,1,.22.88,1.7,1.7,0,0,1-.22.91,1.82,1.82,0,0,1-.57.6,2.76,2.76,0,0,1-.77.33A3.19,3.19,0,0,1,466,211.26Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M469.32,211.16l1.61-7.6h.26l-.8,3.76-.19.91c-.07.28-.14.58-.22.89h0l3.45-3.24h.33l-2.45,2.3,1.52,3h-.29l-1.42-2.81-1.19,1.09-.36,1.72Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M473.71,211.16l1.12-5.28h.26L474,211.16Zm1.57-6.59c-.15,0-.23-.07-.23-.22a.56.56,0,0,1,.08-.27.25.25,0,0,1,.22-.13.21.21,0,0,1,.17.07.3.3,0,0,1,.05.15.54.54,0,0,1-.07.27A.24.24,0,0,1,475.28,204.57Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M475.78,211.16l1.12-5.28h.22l-.28,1.39h0a3.21,3.21,0,0,1,.48-.66,2.71,2.71,0,0,1,.74-.59,2,2,0,0,1,1-.24,1.4,1.4,0,0,1,1,.33,1.26,1.26,0,0,1,.35,1,3.29,3.29,0,0,1-.08.66l-.72,3.42h-.26l.73-3.45a2.1,2.1,0,0,0,.06-.31,2.72,2.72,0,0,0,0-.28,1,1,0,0,0-.3-.82A1.2,1.2,0,0,0,479,206a1.84,1.84,0,0,0-1,.34,3,3,0,0,0-.85.89,3.38,3.38,0,0,0-.49,1.16l-.58,2.74Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.9,242.11a1.28,1.28,0,0,1,1,.26,1.06,1.06,0,0,1,.46.73,70.83,70.83,0,0,0-5.89,10.67q-2.37,5.41-2.15,7.42a3,3,0,0,1-2.26,0,2,2,0,0,1-1.47-1.77q-.24-1.87,2.43-6.66a49.54,49.54,0,0,1,5.59-8.19,17.57,17.57,0,0,1-5.48,1.72,2.44,2.44,0,0,1-2.31-.55,2.51,2.51,0,0,1-.37-2.09c.08.13.81.15,2.19.09a40.16,40.16,0,0,0,4.64-.55A10.84,10.84,0,0,0,354.9,242.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.41,239.05a12.18,12.18,0,0,1,7,.79,5,5,0,0,1,3,3.93,6.38,6.38,0,0,1-1,4.11,10.85,10.85,0,0,1-3.4,3.55,10.46,10.46,0,0,1-4.53,1.75,5.43,5.43,0,0,1-2.63-.2,19.72,19.72,0,0,0-.94,6.85,4,4,0,0,1-2.9.14,2.19,2.19,0,0,1-1.41-1.9q-.23-1.67,1.13-5.41a36.41,36.41,0,0,1,3.35-6.93c1.32-2.13,2.44-3.25,3.34-3.36a1.93,1.93,0,0,1,1.77.59,26.61,26.61,0,0,0-3.91,8.6,9.6,9.6,0,0,0,2.47-1,13.85,13.85,0,0,0,2.45-1.71,7.22,7.22,0,0,0,1.83-2.43,5.1,5.1,0,0,0,.48-2.88,3.24,3.24,0,0,0-1.6-2.6,5.85,5.85,0,0,0-3.62-.48,9.61,9.61,0,0,0-3.88,1.42,10.92,10.92,0,0,0-3,2.67,12.93,12.93,0,0,0-1.74,3.15,6.13,6.13,0,0,0-.45,2.92,2.78,2.78,0,0,0,.53,1.37,2.2,2.2,0,0,1-1,.3,3,3,0,0,1-2.3-.63,3.36,3.36,0,0,1-1.24-2.37,6.11,6.11,0,0,1,1.4-4.49,13.65,13.65,0,0,1,4.6-3.8A17.62,17.62,0,0,1,371.41,239.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.6,246.88a1.11,1.11,0,0,1,.81.07.57.57,0,0,1,.3.64,6.5,6.5,0,0,1-2.11,2.5,6,6,0,0,1-2.72,1.09,1.88,1.88,0,0,1-.44,0,12.84,12.84,0,0,1-2.5,3.77,5.54,5.54,0,0,1-3.28,1.76,3.09,3.09,0,0,1-2.45-.64,3.42,3.42,0,0,1-1.21-2.37,9.05,9.05,0,0,1,.42-3.72,10.72,10.72,0,0,1,2-3.81,4.7,4.7,0,0,1,3-1.91,3.63,3.63,0,0,1,1.6.15,2.35,2.35,0,0,1,1.66-1.21,1.44,1.44,0,0,1,1.24.43,2.87,2.87,0,0,1,.66,1.67,9.49,9.49,0,0,1-.48,4A4.62,4.62,0,0,0,394.6,246.88Zm-8.78,7.05a2.5,2.5,0,0,0,1.49-1,9.27,9.27,0,0,0,1.4-2.27,3.74,3.74,0,0,1-1.28-2.64,6.75,6.75,0,0,1,.1-2.24c-.75.06-1.49.89-2.2,2.48a8,8,0,0,0-.84,4.17C384.63,253.53,385.07,254,385.82,253.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.27,246.75a32.7,32.7,0,0,1-3.46,5.75c-1.17,1.48-2.24,2.29-3.22,2.41a2.18,2.18,0,0,1-1.6-.44,2.44,2.44,0,0,1-.94-1.81,10.68,10.68,0,0,1,.41-3.7,18.38,18.38,0,0,1,1.57-4.21c.66-1.25,1.27-1.92,1.85-2a2.22,2.22,0,0,1,1.22.15,1.63,1.63,0,0,1,.75.62,16,16,0,0,0-1.57,3.46,9.22,9.22,0,0,0-.68,3.91c.07.55.27.81.59.77.79-.1,2.11-2,4-5.62a1,1,0,0,1,.79.09A.6.6,0,0,1,402.27,246.75Zm-3-5.58a1.4,1.4,0,0,1-1.16-.29,1.65,1.65,0,0,1-.64-1.17,3.84,3.84,0,0,1,.36-2,1.73,1.73,0,0,1,1.31-1.19,2.26,2.26,0,0,1,1.6.41c.49.35.76.67.79,1a4.34,4.34,0,0,0-1.21,1.36A9.84,9.84,0,0,0,399.25,241.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.05,244.28a1,1,0,0,1,.79.09.58.58,0,0,1,.32.61,26.08,26.08,0,0,1-3.55,5.42c-1.27,1.47-2.44,2.27-3.52,2.41a1.73,1.73,0,0,1-1.39-.36A2.22,2.22,0,0,1,407,251c-.18-1.38.47-3.66,2-6.86l-.1-.07a19.67,19.67,0,0,0-3.33,4.52,23.88,23.88,0,0,0-2.7,5.51,2.18,2.18,0,0,1-2,.13,2.08,2.08,0,0,1-1.23-1.82,11.62,11.62,0,0,1,.36-3.71,19.25,19.25,0,0,1,1.49-4.3c.63-1.29,1.24-2,1.81-2a2.35,2.35,0,0,1,1.15.16,1.67,1.67,0,0,1,.86.64,15.43,15.43,0,0,0-1.48,3.24,15.12,15.12,0,0,0-.92,4.14,48.41,48.41,0,0,1,3.87-6.15q2.28-3.15,3.32-3.28a2.43,2.43,0,0,1,1.46.3,1.79,1.79,0,0,1,.94,1,15.89,15.89,0,0,0-1.4,3.36,7.86,7.86,0,0,0-.5,3.1c.06.46.21.68.46.65.44-.06,1-.59,1.79-1.58A25.07,25.07,0,0,0,415.05,244.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.31,243.1a1,1,0,0,1,.79.09.6.6,0,0,1,.33.61,29.28,29.28,0,0,1-4,5.89c-1.45,1.64-2.81,2.55-4.08,2.71a2.79,2.79,0,0,1-3.19-2.55c-.2-1.55.23-3.88,1.27-7l-.11,0a1.14,1.14,0,0,1-1.07-.61c-.32-.46-.38-.83-.2-1.1a8.54,8.54,0,0,0,2.05-.21,21.77,21.77,0,0,1,2.08-4.11c.73-1.09,1.42-1.68,2.05-1.76a1.91,1.91,0,0,1,1.06.18,1.67,1.67,0,0,1,.77.64,18,18,0,0,0-2.36,4.19l.71-.18.69-.18.41-.08a1.2,1.2,0,0,1,1.2.46,1.42,1.42,0,0,1,.3,1.19c-.34.08-1,.22-2,.41s-1.72.32-2.12.41c-1,2.8-1.46,4.88-1.29,6.22.12.9.48,1.31,1.1,1.23a4.81,4.81,0,0,0,2.61-1.94A26.73,26.73,0,0,0,424.31,243.1Z",
    fill: "#fff"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M319.68,263.58h.4l-5.2,17.64h-.15L311,268.68l-3.65,12.54h-.15l-5.35-17.64h.37l5.06,16.58L310.78,268h.38l3.65,12.14Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M328.81,280.34v.39H322.1V263.6h6.57v.4h-6.16v7.87h6.16v.42h-6.16v8Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M337.66,280.36v.35H331.8a.22.22,0,0,1-.14-.06.16.16,0,0,1-.07-.13V263.6h.4v16.76Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M345.88,280.36v.35H340a.22.22,0,0,1-.13-.06.16.16,0,0,1-.07-.13V263.6h.4v16.76Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M358.1,263.58v17.13h-.37l-9.35-16.45v16.45H348V263.56h.35L357.73,280v-16.4Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M367.61,280.34v.39H360.9V263.6h6.57v.4h-6.15v7.87h6.15v.42h-6.15v8Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M379,276.66a4.26,4.26,0,0,1-.65,2.29,4.48,4.48,0,0,1-1.7,1.62,4.62,4.62,0,0,1-2.27.58,5.16,5.16,0,0,1-2.88-.77,4.94,4.94,0,0,1-1.84-2.29l.33-.19a5.43,5.43,0,0,0,1.75,2.16,4.59,4.59,0,0,0,2.64.72,4.19,4.19,0,0,0,3-1.19,3.84,3.84,0,0,0,1.26-2.91,3.76,3.76,0,0,0-.35-1.59,4.28,4.28,0,0,0-.94-1.3,7.91,7.91,0,0,0-1.28-1,10.75,10.75,0,0,0-1.48-.74c-.4-.17-.72-.3-.95-.41a8.55,8.55,0,0,1-.87-.43,6,6,0,0,1-.83-.5,7.87,7.87,0,0,1-.67-.59,2.94,2.94,0,0,1-.55-.72,4.39,4.39,0,0,1-.33-.87,4.57,4.57,0,0,1,1.06-4.16,4,4,0,0,1,3-1.21,5.37,5.37,0,0,1,2.14.45,3.38,3.38,0,0,1,1.57,1.26l-.26.25a4.26,4.26,0,0,0-3.32-1.56,3.8,3.8,0,0,0-2.81,1.11,3.75,3.75,0,0,0-1.1,2.76,3.32,3.32,0,0,0,.13,1,3.92,3.92,0,0,0,.31.8,2.93,2.93,0,0,0,.52.68,5.92,5.92,0,0,0,.64.55,6.84,6.84,0,0,0,.78.48l.81.4.87.37a10.73,10.73,0,0,1,1.59.8,8.59,8.59,0,0,1,1.37,1.05,4.65,4.65,0,0,1,1,1.41A4.1,4.1,0,0,1,379,276.66Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M389.84,276.66a4.26,4.26,0,0,1-.65,2.29,4.48,4.48,0,0,1-1.7,1.62,4.62,4.62,0,0,1-2.27.58,5.16,5.16,0,0,1-2.88-.77,4.94,4.94,0,0,1-1.84-2.29l.33-.19a5.43,5.43,0,0,0,1.75,2.16,4.59,4.59,0,0,0,2.64.72,4.17,4.17,0,0,0,3-1.19,3.84,3.84,0,0,0,1.26-2.91,3.76,3.76,0,0,0-.35-1.59,4.28,4.28,0,0,0-.94-1.3,7.91,7.91,0,0,0-1.28-1,10.75,10.75,0,0,0-1.48-.74c-.4-.17-.72-.3-.95-.41a8.55,8.55,0,0,1-.87-.43,6.66,6.66,0,0,1-.83-.5,7.87,7.87,0,0,1-.67-.59,2.94,2.94,0,0,1-.55-.72,4.39,4.39,0,0,1-.33-.87,4.57,4.57,0,0,1,1.06-4.16,4,4,0,0,1,3-1.21,5.37,5.37,0,0,1,2.14.45,3.38,3.38,0,0,1,1.57,1.26l-.26.25a4.26,4.26,0,0,0-3.32-1.56,3.81,3.81,0,0,0-2.81,1.11,3.75,3.75,0,0,0-1.1,2.76,3.32,3.32,0,0,0,.13,1,3.92,3.92,0,0,0,.31.8,2.93,2.93,0,0,0,.52.68,7.06,7.06,0,0,0,.64.55,7.86,7.86,0,0,0,.78.48l.81.4.87.37a10.73,10.73,0,0,1,1.59.8,8.59,8.59,0,0,1,1.37,1.05,4.65,4.65,0,0,1,1,1.41A4.1,4.1,0,0,1,389.84,276.66Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M412.88,278.67l.32.24a9.73,9.73,0,0,1-2.86,1.67,9.66,9.66,0,0,1-7-.12,9.5,9.5,0,0,1-3-1.92,8.84,8.84,0,0,1-2-2.87,8.4,8.4,0,0,1-.74-3.5,8.54,8.54,0,0,1,1.25-4.53,9.12,9.12,0,0,1,3.39-3.28,9.7,9.7,0,0,1,10.4.67l-.22.32a9.21,9.21,0,0,0-11.82.71,8.74,8.74,0,0,0-1.91,2.76,8.33,8.33,0,0,0,.49,7.67,8.75,8.75,0,0,0,3.26,3.13,9,9,0,0,0,4.48,1.16,9.18,9.18,0,0,0,3.18-.56A8.61,8.61,0,0,0,412.88,278.67Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M425.32,263.6v17.11H425v-8.25h-9v8.25h-.4V263.6h.4V272h9V263.6Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M434.82,280.34v.39h-6.71V263.6h6.57v.4h-6.15v7.87h6.15v.42h-6.15v8Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M452.11,278.67l.32.24a9.73,9.73,0,0,1-2.86,1.67,9.66,9.66,0,0,1-7-.12,9.5,9.5,0,0,1-3-1.92,9,9,0,0,1-2-2.87,8.4,8.4,0,0,1-.74-3.5,8.54,8.54,0,0,1,1.25-4.53,9.12,9.12,0,0,1,3.39-3.28A9.7,9.7,0,0,1,452,265l-.22.32a9.21,9.21,0,0,0-11.82.71,8.74,8.74,0,0,0-1.91,2.76,8.33,8.33,0,0,0,.49,7.67,8.75,8.75,0,0,0,3.26,3.13,9,9,0,0,0,4.48,1.16,9.18,9.18,0,0,0,3.18-.56A8.61,8.61,0,0,0,452.11,278.67Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M455.4,272.07l8.73,8.54-.28.27-8.63-8.44v8.27h-.39V263.58h.39v8.11l8-8.25.29.29Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.71,320.43a12.18,12.18,0,0,1,7,.8,5,5,0,0,1,3,3.92,6.4,6.4,0,0,1-1,4.12,10.94,10.94,0,0,1-3.4,3.55,10.57,10.57,0,0,1-4.53,1.74,5.32,5.32,0,0,1-2.63-.19,19.72,19.72,0,0,0-.94,6.85,4,4,0,0,1-2.9.13,2.16,2.16,0,0,1-1.41-1.9q-.22-1.67,1.13-5.4a36.12,36.12,0,0,1,3.35-6.93c1.32-2.13,2.44-3.25,3.34-3.37a1.94,1.94,0,0,1,1.77.6,26.65,26.65,0,0,0-3.91,8.59,9.55,9.55,0,0,0,2.47-1,13.4,13.4,0,0,0,2.45-1.72,7.28,7.28,0,0,0,1.83-2.42,5.1,5.1,0,0,0,.48-2.88,3.26,3.26,0,0,0-1.6-2.61,5.93,5.93,0,0,0-3.62-.47,9.45,9.45,0,0,0-3.88,1.41,11.11,11.11,0,0,0-3,2.68,12.57,12.57,0,0,0-1.74,3.15,6.1,6.1,0,0,0-.45,2.92,2.71,2.71,0,0,0,.53,1.36,2,2,0,0,1-1,.3,3,3,0,0,1-2.3-.62,3.37,3.37,0,0,1-1.24-2.38,6.12,6.12,0,0,1,1.4-4.49,13.89,13.89,0,0,1,4.6-3.8A18,18,0,0,1,223.71,320.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.36,328.08a1,1,0,0,1,.79.09.6.6,0,0,1,.33.62q-4,7.43-6.5,7.75a1.8,1.8,0,0,1-1.66-.65,3.5,3.5,0,0,1-.83-1.92,2.21,2.21,0,0,1,0-.47c-1.9,3-3.5,4.54-4.78,4.7a2.07,2.07,0,0,1-1.54-.47,2.79,2.79,0,0,1-.93-2,10,10,0,0,1,.41-3.94,12.78,12.78,0,0,1,2-4.16,4.65,4.65,0,0,1,3.07-2.1,2.92,2.92,0,0,1,1.79.32,2.77,2.77,0,0,1,1.27,1.42c.69-1.47,1.38-2.25,2.09-2.34a2,2,0,0,1,2,1,8,8,0,0,1-.69,1.69,21,21,0,0,1-1.17,2.06,9.6,9.6,0,0,0-.16,2.65c.09.69.3,1,.62,1C245.14,333.26,246.44,331.5,248.36,328.08Zm-11.09,6.76c.3,0,.81-.52,1.52-1.45a25.38,25.38,0,0,0,2.09-3.27,16.16,16.16,0,0,1,.43-1.61c-.52-.75-1-1.1-1.53-1s-1.06.53-1.58,1.38a10.67,10.67,0,0,0-1.16,2.8,6.63,6.63,0,0,0-.28,2.4Q236.87,334.9,237.27,334.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.69,325.74a1,1,0,0,1,.79.1.59.59,0,0,1,.32.61c-1.47,2.64-3,4.06-4.51,4.26a2.62,2.62,0,0,1-1.47-.25,14.65,14.65,0,0,1-2.61,3.27,5.06,5.06,0,0,1-2.66,1.46,2.27,2.27,0,0,1-1.85-.54,3,3,0,0,1-1-2,4.39,4.39,0,0,1,0-.55c-1.45,2.58-2.79,3.95-4,4.11a2.48,2.48,0,0,1-1.63-.44,2.44,2.44,0,0,1-1-1.91,10.75,10.75,0,0,1,.4-3.79,16.89,16.89,0,0,1,1.59-4.17c.67-1.22,1.3-1.87,1.9-1.95a2.51,2.51,0,0,1,1.09.18,1.37,1.37,0,0,1,.82.6,14.45,14.45,0,0,0-1.53,3.28,8.51,8.51,0,0,0-.73,3.76c.08.61.31.9.69.85.67-.09,1.61-1.44,2.81-4.07a14.47,14.47,0,0,1,1.06-3.43q.66-1.41,1.56-1.53a2.07,2.07,0,0,1,1.05.22,2,2,0,0,1,.89.77,14.36,14.36,0,0,1-1.49,2.76,9,9,0,0,0-.45,3.59c.1.85.39,1.24.85,1.18.84-.11,1.86-1.11,3.06-3a4.83,4.83,0,0,1-.42-1.47,6.48,6.48,0,0,1,.5-3.48c.48-1.11,1.11-1.72,1.9-1.82a1.61,1.61,0,0,1,1.54.65,12.08,12.08,0,0,1-1.34,5.75,2.86,2.86,0,0,0,2-.71A7.15,7.15,0,0,0,266.69,325.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.85,323.81a1.08,1.08,0,0,1,.79.09.59.59,0,0,1,.32.62,27,27,0,0,1-3.8,5.37,7,7,0,0,1-3.88,2.48,2.07,2.07,0,0,1-1.72-.5,3.59,3.59,0,0,1-1-1.84c-1.86,2.49-3.44,3.83-4.72,4a2.31,2.31,0,0,1-1.69-.46,2.53,2.53,0,0,1-1-1.86,10.19,10.19,0,0,1,.44-3.95,13.32,13.32,0,0,1,2.09-4.24,4.77,4.77,0,0,1,3.11-2.15,2.32,2.32,0,0,1,2.49,1.18,23.22,23.22,0,0,1,2.87-6.27c1.18-1.79,2.39-2.77,3.61-2.92a2,2,0,0,1,1.47.29,1.58,1.58,0,0,1,.71,1.16c.15,1.2-.46,3.11-1.83,5.71a27.07,27.07,0,0,1-4.6,6.45,4.47,4.47,0,0,0,0,.84c.12,1,.55,1.4,1.3,1.3a4.45,4.45,0,0,0,2.44-1.66A20.54,20.54,0,0,0,281.85,323.81Zm-12.32,7c.71-.09,1.66-1,2.84-2.7a20.53,20.53,0,0,1,.59-4.31,1.29,1.29,0,0,0-1.12-.56c-.81.1-1.56,1-2.27,2.6a8,8,0,0,0-.86,4C268.79,330.57,269.07,330.88,269.53,330.82Zm10.23-15.16c-.5.07-1.18,1.12-2,3.17a32.91,32.91,0,0,0-1.91,6,30.36,30.36,0,0,0,3-5.11c.91-1.9,1.33-3.16,1.25-3.77C280.06,315.74,280,315.64,279.76,315.66Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.52,323.68a32.1,32.1,0,0,1-3.46,5.75c-1.17,1.48-2.24,2.29-3.22,2.41a2.19,2.19,0,0,1-1.6-.44,2.41,2.41,0,0,1-.93-1.81,10.4,10.4,0,0,1,.4-3.7,19,19,0,0,1,1.57-4.21c.66-1.25,1.28-1.91,1.85-2a2.3,2.3,0,0,1,1.22.16,1.52,1.52,0,0,1,.75.62,15.72,15.72,0,0,0-1.56,3.45,9.13,9.13,0,0,0-.69,3.91c.07.55.27.81.6.77q1.17-.15,4-5.62a1,1,0,0,1,.78.09A.58.58,0,0,1,289.52,323.68Zm-3-5.57a1.48,1.48,0,0,1-1.16-.29,1.63,1.63,0,0,1-.63-1.18,3.79,3.79,0,0,1,.35-2,1.74,1.74,0,0,1,1.31-1.2,2.25,2.25,0,0,1,1.6.41c.5.35.76.67.8,1a4.26,4.26,0,0,0-1.22,1.35A9.89,9.89,0,0,0,286.5,318.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.79,322.38a23.24,23.24,0,0,1-4.3,6.16,8.31,8.31,0,0,1-4.65,2.55,3.43,3.43,0,0,1-4-3.17,8.63,8.63,0,0,1,.51-3.87,11.47,11.47,0,0,1,2.2-3.86,5,5,0,0,1,3.1-1.9,4.35,4.35,0,0,1,2.36.37,2,2,0,0,1,1.31,1.59,3.36,3.36,0,0,1-1.13,2.69c-.87.92-1.66,1.31-2.38,1.15a8.77,8.77,0,0,0,.88-3.83q-.07-.63-.54-.57c-.32,0-.73.45-1.21,1.22a11.63,11.63,0,0,0-1.25,2.83,6.85,6.85,0,0,0-.36,2.91c.16,1.25.77,1.81,1.85,1.67a6.08,6.08,0,0,0,3.54-2.25,19.5,19.5,0,0,0,3-4.4,1,1,0,0,1,.78.09A.61.61,0,0,1,299.79,322.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23,319.94a1,1,0,0,1,.78.09.62.62,0,0,1,.33.62q-3.9,7.43-6.55,7.76a1.85,1.85,0,0,1-1.49-.45,2.6,2.6,0,0,1-.81-1.74,5.69,5.69,0,0,1-.05-.87q-2.87,4.2-4.84,4.45a2.09,2.09,0,0,1-1.57-.45,2.57,2.57,0,0,1-.89-1.81,11.18,11.18,0,0,1,.37-3.91,16.58,16.58,0,0,1,1.55-4.16c.65-1.2,1.28-1.84,1.87-1.91a2.24,2.24,0,0,1,1.18.17,1.69,1.69,0,0,1,.82.59,15.56,15.56,0,0,0-1.54,3.44,9.39,9.39,0,0,0-.68,3.95c.07.52.25.76.56.72.69-.09,1.8-1.37,3.31-3.84a15.72,15.72,0,0,1,1.36-3.94c.59-1.13,1.2-1.74,1.85-1.83a2,2,0,0,1,1.16.24,1.34,1.34,0,0,1,.73.78A13.42,13.42,0,0,1,308,321.1a10.18,10.18,0,0,0-.27,3.19c.09.66.32,1,.7.91Q309.42,325.07,312.23,319.94Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.67,318.61a1.08,1.08,0,0,1,.79.09.6.6,0,0,1,.32.62,29.68,29.68,0,0,1-3.71,5.85q-2.08,2.55-3.78,2.76a2.15,2.15,0,0,1-1.65-.44,2.21,2.21,0,0,1-.86-1.55,9.25,9.25,0,0,1,1-3.86,10,10,0,0,0,1-3.5c-.06-.42-.39-.75-1-1l-1.45,3a1.19,1.19,0,0,1-.73-.14.63.63,0,0,1-.38-.57,20,20,0,0,0,1.18-2.87,1.31,1.31,0,0,1-.83-1,2,2,0,0,1,.56-1.59,2.39,2.39,0,0,1,1.56-.87.8.8,0,0,1,1,.77,3.35,3.35,0,0,1-.25,1.7,1.22,1.22,0,0,0,.32.18l.46.2.5.25c1.4.71,2.13,1.36,2.2,1.94a7.44,7.44,0,0,1-.68,2.74,7.37,7.37,0,0,0-.69,2.73q.07.63.51.57c.42-.05,1.1-.71,2-2A31.19,31.19,0,0,0,322.67,318.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.2,317.27a1,1,0,0,1,.78.09.6.6,0,0,1,.33.62q-4.4,8.13-9.06,8.73a3.78,3.78,0,0,1-2.84-.62,3.52,3.52,0,0,1-1.33-2.51,8.74,8.74,0,0,1,.52-3.86,11.28,11.28,0,0,1,2.22-3.88,5.2,5.2,0,0,1,3.16-1.93,3.66,3.66,0,0,1,2.36.46,2.19,2.19,0,0,1,1.18,1.64c.12.94-.37,2.08-1.49,3.43a13.83,13.83,0,0,1-4.44,3.46,1.53,1.53,0,0,0,1.84,1.14,6.52,6.52,0,0,0,3.68-2.34A18.88,18.88,0,0,0,333.2,317.27Zm-5.78-1.95c-.51.07-1.13.85-1.85,2.34a10.56,10.56,0,0,0-1.14,4,11.3,11.3,0,0,0,2.69-2.91,4.5,4.5,0,0,0,.94-2.78C328,315.49,327.79,315.27,327.42,315.32Z",
    fill: "#fff"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M204.8,340.18v17.14h-.37l-9.35-16.46v16.46h-.35V340.16h.35l9.35,16.43V340.18Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M211.67,339.7h.17l5.35,17.64h-.4l-2.48-8.14h-5l-2.37,8.14h-.42Zm.06,1.1-2.35,8h4.81Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M220.22,340.21v17.11h-.38V340.21Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M230.07,357v.36H224.2a.19.19,0,0,1-.13-.06.17.17,0,0,1-.07-.14V340.21h.4V357Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M246.24,340.21v.39H242.3v16.72h-.38V340.6h-4v-.39Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M250.52,349.07h-1.36l6.65,8.14-.32.28-6.57-8.09v7.92h-.4V340.4a.16.16,0,0,1,.06-.13.2.2,0,0,1,.15-.06h1.79a4.36,4.36,0,0,1,3.15,1.25,4.12,4.12,0,0,1,1.3,3.07v.09a4.47,4.47,0,0,1-4.45,4.45Zm4-4.45v-.09a3.69,3.69,0,0,0-1.18-2.79,4,4,0,0,0-2.87-1.14h-1.6v8.07h1.6a4.06,4.06,0,0,0,4-4.05Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M259.28,340.21v17.11h-.38V340.21Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M276.89,339.92l3.46,17.42H280l-3.35-16.69-5.17,12.62h-.35l-5.57-12.62-2.8,16.69h-.38l2.92-17.4h.38l5.62,12.74,5.24-12.76Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M295.9,349l7.6,8.12-.28.26-2.77-2.94a5.83,5.83,0,0,1-2.17,2.45,5.74,5.74,0,0,1-3.18.93,5.87,5.87,0,0,1-5.11-2.92,5.72,5.72,0,0,1-.79-2.93A5.65,5.65,0,0,1,290,349a5.78,5.78,0,0,1,2.15-2.13,4.15,4.15,0,0,1-1.18-1.39,3.94,3.94,0,0,1,.73-4.58,4,4,0,0,1,5.58-.06,3.79,3.79,0,0,1,1.22,2.66l-.39,0a3.42,3.42,0,0,0-1.1-2.41,3.62,3.62,0,0,0-5,.06,3.38,3.38,0,0,0-1.06,2.52,3.56,3.56,0,0,0,.44,1.73,3.06,3.06,0,0,0,1.1,1.2c.18.09.27.18.27.26a.2.2,0,0,1-.13.18,5.48,5.48,0,0,0-2.19,2,5.46,5.46,0,0,0,4.67,8.33,5.27,5.27,0,0,0,3-.91,5.46,5.46,0,0,0,2-2.38l-4.53-4.87Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M320.12,352.81a4.59,4.59,0,0,1-1.18,3.1,4.09,4.09,0,0,1-1.49,1,5.4,5.4,0,0,1-2.06.38H312.2V340.21h3.06a4.22,4.22,0,0,1,3,1.17,3.82,3.82,0,0,1,1.26,2.92,4.05,4.05,0,0,1-.82,2.47,4.32,4.32,0,0,1-2.11,1.55A4.48,4.48,0,0,1,319.2,350,4.68,4.68,0,0,1,320.12,352.81Zm-1-8.53a3.38,3.38,0,0,0-1.21-2.68,4.55,4.55,0,0,0-3.06-1h-2.22v7.62H315a4.09,4.09,0,0,0,2.88-1.12A3.68,3.68,0,0,0,319.11,344.28Zm.61,8.53a4.28,4.28,0,0,0-.29-1.56,4.32,4.32,0,0,0-.86-1.34,3.93,3.93,0,0,0-1.48-1,5.55,5.55,0,0,0-2-.36h-2.42v8.32h2.77a4.87,4.87,0,0,0,1.87-.35,3.68,3.68,0,0,0,1.37-.94,4.11,4.11,0,0,0,.81-1.31A4,4,0,0,0,319.72,352.81Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M332,340.21v13.06a4.28,4.28,0,0,1-1.34,3.18,4.61,4.61,0,0,1-3.33,1.31,5.16,5.16,0,0,1-2.45-.6,4.75,4.75,0,0,1-1.81-1.63,4,4,0,0,1-.68-2.26V340.21h.39v13.06a3.72,3.72,0,0,0,1.35,2.88,4.63,4.63,0,0,0,3.2,1.21,4.18,4.18,0,0,0,3-1.2,3.89,3.89,0,0,0,1.23-2.89V340.21Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M341.53,348.48v.42h-6.14v8.44H335V340.21h6.58v.39h-6.14v7.88Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M351,348.48v.42h-6.13v8.44h-.44V340.21H351v.39h-6.13v7.88Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.68,113.17a1.92,1.92,0,0,1-1.17-.19,2.62,2.62,0,0,0,.71-1.85.65.65,0,0,0-.27-.48.81.81,0,0,0-.61-.13,2.68,2.68,0,0,0-1.63.91,2,2,0,0,0-.6,1.69,2.21,2.21,0,0,0,.07.32.72.72,0,0,0,.14.24,1.52,1.52,0,0,0,.17.18.65.65,0,0,0,.23.15l.22.12.27.1.24.09,1,.39a7.64,7.64,0,0,1,.8.43,2.28,2.28,0,0,1,.74.65,1.93,1.93,0,0,1,.31.85,2.42,2.42,0,0,1-.81,2.07,5.32,5.32,0,0,1-2.74,1.43,19.36,19.36,0,0,0-.37,3.07c-.86.11-1.33-.1-1.4-.65a5.79,5.79,0,0,1,.6-2.25,4.4,4.4,0,0,1-2-.32,1.54,1.54,0,0,1-1-1.3,1.3,1.3,0,0,1,.38-1.12,1.86,1.86,0,0,1,1.17-.59,2.2,2.2,0,0,1,.67,0,2.69,2.69,0,0,0,0,.69,1.82,1.82,0,0,0,.53,1.12,1.33,1.33,0,0,0,1.06.29,1.6,1.6,0,0,0,1.1-.57,1.44,1.44,0,0,0,.29-1.14,1,1,0,0,0-.34-.62,2.24,2.24,0,0,0-.55-.36,7.71,7.71,0,0,0-.78-.26,5.18,5.18,0,0,1-1.63-.83,2,2,0,0,1-.76-1.39,3,3,0,0,1,.91-2.58,5.69,5.69,0,0,1,3-1.62c.29-1.81.72-2.75,1.3-2.83a1.21,1.21,0,0,1,.55.08,1,1,0,0,1,.44.3,9.29,9.29,0,0,0-.89,2.29,3.33,3.33,0,0,1,1.75.41,1.56,1.56,0,0,1,.77,1.17,1.58,1.58,0,0,1-.47,1.33A2.21,2.21,0,0,1,227.68,113.17Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.94,100.77a1.28,1.28,0,0,1,1,.25,1.12,1.12,0,0,1,.46.73,71.41,71.41,0,0,0-5.89,10.68c-1.59,3.6-2.3,6.08-2.15,7.42a3,3,0,0,1-2.27,0,2,2,0,0,1-1.46-1.78q-.24-1.86,2.42-6.65a49.66,49.66,0,0,1,5.6-8.2,17.57,17.57,0,0,1-5.49,1.73c-1.13.14-1.9,0-2.3-.56a2.5,2.5,0,0,1-.37-2.09q.1.19,2.19.09a38.3,38.3,0,0,0,4.64-.55A10.64,10.64,0,0,0,242.94,100.77Z",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.68,191.7a1.85,1.85,0,0,1-1.17-.19,2.6,2.6,0,0,0,.71-1.84.67.67,0,0,0-.27-.49.81.81,0,0,0-.61-.13,2.65,2.65,0,0,0-1.63.92,2,2,0,0,0-.6,1.69,2.05,2.05,0,0,0,.07.31.72.72,0,0,0,.14.24,1,1,0,0,0,.17.18.81.81,0,0,0,.23.16l.22.11.27.11.24.09,1,.38a7.64,7.64,0,0,1,.8.43,2.28,2.28,0,0,1,.74.65,2,2,0,0,1,.31.86,2.41,2.41,0,0,1-.81,2.06,5.25,5.25,0,0,1-2.74,1.43,19.49,19.49,0,0,0-.37,3.07c-.86.11-1.33-.1-1.4-.64a5.78,5.78,0,0,1,.6-2.26,4.26,4.26,0,0,1-2-.32,1.53,1.53,0,0,1-1-1.29,1.31,1.31,0,0,1,.38-1.13,1.85,1.85,0,0,1,1.17-.58,1.91,1.91,0,0,1,.67,0,2.69,2.69,0,0,0,0,.69,1.82,1.82,0,0,0,.53,1.12,1.29,1.29,0,0,0,1.06.29,1.63,1.63,0,0,0,1.1-.56,1.47,1.47,0,0,0,.29-1.15.92.92,0,0,0-.34-.61,2.31,2.31,0,0,0-.55-.37,7.71,7.71,0,0,0-.78-.26,5.18,5.18,0,0,1-1.63-.83,2,2,0,0,1-.76-1.38,3,3,0,0,1,.91-2.59,5.69,5.69,0,0,1,3-1.62c.29-1.81.72-2.75,1.3-2.82a1,1,0,0,1,.55.08.92.92,0,0,1,.44.29,9.29,9.29,0,0,0-.89,2.29,3.33,3.33,0,0,1,1.75.42,1.54,1.54,0,0,1,.77,1.16A1.58,1.58,0,0,1,229,191,2.21,2.21,0,0,1,227.68,191.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.94,179.3a1.28,1.28,0,0,1,1,.25,1.14,1.14,0,0,1,.46.73A71.41,71.41,0,0,0,238.52,191c-1.59,3.6-2.3,6.08-2.15,7.42a3,3,0,0,1-2.27,0,2,2,0,0,1-1.46-1.77q-.24-1.87,2.42-6.66a49.13,49.13,0,0,1,5.6-8.19,17.81,17.81,0,0,1-5.49,1.72c-1.13.14-1.9,0-2.3-.56a2.48,2.48,0,0,1-.37-2.08,5.44,5.44,0,0,0,2.19.08,40.23,40.23,0,0,0,4.64-.54A10.84,10.84,0,0,0,242.94,179.3Z",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.93,273.46a2,2,0,0,1-1.17-.19,2.62,2.62,0,0,0,.71-1.85.73.73,0,0,0-.27-.49.87.87,0,0,0-.62-.12,2.63,2.63,0,0,0-1.62.91,2,2,0,0,0-.6,1.69,1.07,1.07,0,0,0,.07.32.84.84,0,0,0,.14.24l.16.18a.91.91,0,0,0,.23.15l.23.11a1.38,1.38,0,0,0,.27.11l.24.09,1,.39a8.22,8.22,0,0,1,.79.42,2.29,2.29,0,0,1,.74.65,1.85,1.85,0,0,1,.31.86,2.38,2.38,0,0,1-.8,2.07,5.36,5.36,0,0,1-2.74,1.43,19.64,19.64,0,0,0-.38,3.07c-.86.11-1.32-.11-1.39-.65a5.79,5.79,0,0,1,.6-2.25,4.44,4.44,0,0,1-2-.32,1.57,1.57,0,0,1-1-1.3,1.35,1.35,0,0,1,.38-1.13,2,2,0,0,1,1.85-.54,2.67,2.67,0,0,0,0,.68,1.8,1.8,0,0,0,.54,1.12,1.24,1.24,0,0,0,1,.29,1.57,1.57,0,0,0,1.1-.56,1.43,1.43,0,0,0,.3-1.15,1,1,0,0,0-.34-.61,2.14,2.14,0,0,0-.55-.36,7.71,7.71,0,0,0-.78-.26,5.59,5.59,0,0,1-1.64-.84,2,2,0,0,1-.76-1.38,3.08,3.08,0,0,1,.92-2.59,5.57,5.57,0,0,1,3-1.61c.28-1.81.71-2.76,1.29-2.83a1.13,1.13,0,0,1,.56.08,1.07,1.07,0,0,1,.44.3,9.47,9.47,0,0,0-.9,2.29,3.37,3.37,0,0,1,1.76.41,1.58,1.58,0,0,1,.3,2.49A2.25,2.25,0,0,1,223.93,273.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46,261.74a33.28,33.28,0,0,0-3.18,9.44q-1.23,6-.81,8.79a6,6,0,0,1-1.42.34,2.85,2.85,0,0,1-1.7-.29,1.66,1.66,0,0,1-1-1.34,13.72,13.72,0,0,1,.62-4.51,67.38,67.38,0,0,1,2.2-6.84l-.12-.05c-1.38,1.87-2.6,2.94-3.66,3.19-.76.17-1.24-.18-1.45-1.05a8.56,8.56,0,0,0,2.75-2.16,44.83,44.83,0,0,0,3.92-4.68,3.22,3.22,0,0,1,2.1-1.67,1.84,1.84,0,0,1,1,.18A1.41,1.41,0,0,1,237.46,261.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.39,260.48a33,33,0,0,0-3.19,9.44q-1.22,6-.81,8.78a6.57,6.57,0,0,1-1.41.35,2.87,2.87,0,0,1-1.71-.3,1.65,1.65,0,0,1-1-1.34,13.56,13.56,0,0,1,.63-4.51,66.26,66.26,0,0,1,2.19-6.84l-.12,0q-2.07,2.81-3.66,3.18c-.75.18-1.24-.17-1.44-1a9,9,0,0,0,2.75-2.16,49.92,49.92,0,0,0,3.92-4.68,3.2,3.2,0,0,1,2.09-1.67,1.81,1.81,0,0,1,1,.18A1.43,1.43,0,0,1,247.39,260.48Z",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.94,273.46a2,2,0,0,1-1.17-.19,2.62,2.62,0,0,0,.71-1.85.73.73,0,0,0-.27-.49.87.87,0,0,0-.62-.12,2.63,2.63,0,0,0-1.62.91,2,2,0,0,0-.6,1.69,1.07,1.07,0,0,0,.07.32.84.84,0,0,0,.14.24l.16.18a.91.91,0,0,0,.23.15l.23.11a1.38,1.38,0,0,0,.27.11l.24.09,1,.39c.2.09.47.23.8.42a2.35,2.35,0,0,1,.73.65,1.85,1.85,0,0,1,.31.86,2.38,2.38,0,0,1-.8,2.07,5.36,5.36,0,0,1-2.74,1.43,19.64,19.64,0,0,0-.38,3.07c-.86.11-1.32-.11-1.39-.65a5.79,5.79,0,0,1,.6-2.25,4.44,4.44,0,0,1-2-.32,1.57,1.57,0,0,1-1-1.3,1.38,1.38,0,0,1,.38-1.13,2,2,0,0,1,1.85-.54,3.24,3.24,0,0,0,0,.68,1.8,1.8,0,0,0,.54,1.12,1.25,1.25,0,0,0,1.06.29,1.57,1.57,0,0,0,1.09-.56,1.43,1.43,0,0,0,.3-1.15,1,1,0,0,0-.34-.61,2,2,0,0,0-.55-.36,7.71,7.71,0,0,0-.78-.26,5.59,5.59,0,0,1-1.64-.84,2.09,2.09,0,0,1-.76-1.38,3.08,3.08,0,0,1,.92-2.59,5.57,5.57,0,0,1,3-1.61c.28-1.81.71-2.76,1.3-2.83a1.1,1.1,0,0,1,.55.08,1,1,0,0,1,.44.3,9.47,9.47,0,0,0-.9,2.29,3.37,3.37,0,0,1,1.76.41,1.58,1.58,0,0,1,.3,2.49A2.25,2.25,0,0,1,505.94,273.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.47,261.74a33.28,33.28,0,0,0-3.18,9.44q-1.23,6-.81,8.79a6,6,0,0,1-1.42.34,2.85,2.85,0,0,1-1.7-.29,1.66,1.66,0,0,1-1-1.34,13.72,13.72,0,0,1,.62-4.51,67.38,67.38,0,0,1,2.2-6.84l-.12-.05c-1.38,1.87-2.6,2.94-3.66,3.19-.76.17-1.24-.18-1.45-1.05a8.56,8.56,0,0,0,2.75-2.16,44.83,44.83,0,0,0,3.92-4.68,3.22,3.22,0,0,1,2.1-1.67,1.83,1.83,0,0,1,1,.18A1.41,1.41,0,0,1,519.47,261.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.4,260.48a32.66,32.66,0,0,0-3.18,9.44q-1.23,6-.82,8.78a6.57,6.57,0,0,1-1.41.35,2.87,2.87,0,0,1-1.71-.3,1.65,1.65,0,0,1-1-1.34,13.84,13.84,0,0,1,.63-4.51,66.26,66.26,0,0,1,2.19-6.84l-.12,0q-2.07,2.81-3.66,3.18c-.75.18-1.24-.17-1.44-1a9,9,0,0,0,2.75-2.16,49.92,49.92,0,0,0,3.92-4.68,3.2,3.2,0,0,1,2.09-1.67,1.81,1.81,0,0,1,1,.18A1.43,1.43,0,0,1,529.4,260.48Z",
    fill: "#fff"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508,191.7a1.85,1.85,0,0,1-1.17-.19,2.6,2.6,0,0,0,.71-1.84.67.67,0,0,0-.27-.49.81.81,0,0,0-.61-.13,2.65,2.65,0,0,0-1.63.92,2,2,0,0,0-.6,1.69,1.29,1.29,0,0,0,.07.31.72.72,0,0,0,.14.24,1,1,0,0,0,.17.18.81.81,0,0,0,.23.16l.22.11.27.11.24.09,1,.38a7.64,7.64,0,0,1,.8.43,2.28,2.28,0,0,1,.74.65,2.1,2.1,0,0,1,.31.86,2.41,2.41,0,0,1-.81,2.06,5.25,5.25,0,0,1-2.74,1.43,19.49,19.49,0,0,0-.37,3.07c-.86.11-1.33-.1-1.4-.64a5.78,5.78,0,0,1,.6-2.26,4.26,4.26,0,0,1-2-.32,1.55,1.55,0,0,1-1-1.29,1.37,1.37,0,0,1,.38-1.13,1.88,1.88,0,0,1,1.18-.58,1.91,1.91,0,0,1,.67,0,2.69,2.69,0,0,0,0,.69,1.77,1.77,0,0,0,.53,1.12,1.29,1.29,0,0,0,1.06.29,1.63,1.63,0,0,0,1.1-.56,1.47,1.47,0,0,0,.29-1.15.92.92,0,0,0-.34-.61,2.31,2.31,0,0,0-.55-.37,7.71,7.71,0,0,0-.78-.26,5.18,5.18,0,0,1-1.63-.83,2.08,2.08,0,0,1-.77-1.38,3.07,3.07,0,0,1,.92-2.59,5.69,5.69,0,0,1,3-1.62c.28-1.81.72-2.75,1.3-2.82a1,1,0,0,1,.55.08.92.92,0,0,1,.44.29,9.29,9.29,0,0,0-.89,2.29,3.33,3.33,0,0,1,1.75.42,1.54,1.54,0,0,1,.77,1.16,1.58,1.58,0,0,1-.47,1.33A2.23,2.23,0,0,1,508,191.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.29,179.3a1.28,1.28,0,0,1,1,.25,1.14,1.14,0,0,1,.46.73A71.41,71.41,0,0,0,518.87,191c-1.59,3.6-2.31,6.08-2.15,7.42a3,3,0,0,1-2.27,0,2,2,0,0,1-1.46-1.77q-.24-1.87,2.42-6.66a49.13,49.13,0,0,1,5.6-8.19,17.81,17.81,0,0,1-5.49,1.72c-1.13.14-1.9,0-2.3-.56a2.48,2.48,0,0,1-.37-2.08A5.44,5.44,0,0,0,515,181a40.23,40.23,0,0,0,4.64-.54A10.84,10.84,0,0,0,523.29,179.3Z",
    fill: "#fff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.93,113.65a1.94,1.94,0,0,1-1.18-.19,2.64,2.64,0,0,0,.72-1.85.7.7,0,0,0-.28-.49.85.85,0,0,0-.61-.12,2.71,2.71,0,0,0-1.63.91,2,2,0,0,0-.6,1.69,2.21,2.21,0,0,0,.07.32.61.61,0,0,0,.15.24l.16.18a.76.76,0,0,0,.23.15l.23.11a1.51,1.51,0,0,0,.26.11l.25.09c.45.17.78.3,1,.39a8.18,8.18,0,0,1,.8.42,2.2,2.2,0,0,1,.74.66,1.81,1.81,0,0,1,.31.85,2.38,2.38,0,0,1-.8,2.07,5.4,5.4,0,0,1-2.75,1.43,19.36,19.36,0,0,0-.37,3.07c-.86.11-1.32-.11-1.39-.65a5.79,5.79,0,0,1,.6-2.25,4.42,4.42,0,0,1-2-.32,1.57,1.57,0,0,1-1-1.3,1.32,1.32,0,0,1,.38-1.13,1.93,1.93,0,0,1,1.17-.58,2.18,2.18,0,0,1,.67,0,3.15,3.15,0,0,0,0,.68,1.83,1.83,0,0,0,.54,1.13,1.31,1.31,0,0,0,1.05.29,1.64,1.64,0,0,0,1.1-.57,1.42,1.42,0,0,0,.3-1.14,1,1,0,0,0-.34-.62,2.14,2.14,0,0,0-.55-.36,7.71,7.71,0,0,0-.78-.26,5.46,5.46,0,0,1-1.64-.83,2.07,2.07,0,0,1-.76-1.39,3.06,3.06,0,0,1,.92-2.59,5.6,5.6,0,0,1,3-1.61c.28-1.81.71-2.75,1.29-2.83a1.27,1.27,0,0,1,.56.08,1.14,1.14,0,0,1,.44.3,9.47,9.47,0,0,0-.9,2.29,3.37,3.37,0,0,1,1.76.41,1.57,1.57,0,0,1,.76,1.17,1.52,1.52,0,0,1-.47,1.32A2.2,2.2,0,0,1,506.93,113.65Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.46,101.94a32.86,32.86,0,0,0-3.18,9.44q-1.23,6-.81,8.78a6.3,6.3,0,0,1-1.42.34,2.8,2.8,0,0,1-1.71-.29,1.66,1.66,0,0,1-1-1.34,13.84,13.84,0,0,1,.63-4.51,63.41,63.41,0,0,1,2.2-6.84l-.13,0c-1.38,1.87-2.59,2.94-3.65,3.19-.76.17-1.24-.17-1.45-1a8.9,8.9,0,0,0,2.75-2.17,46.1,46.1,0,0,0,3.92-4.68,3.25,3.25,0,0,1,2.1-1.67,1.79,1.79,0,0,1,1,.18A1.37,1.37,0,0,1,520.46,101.94Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.38,100.67a33.28,33.28,0,0,0-3.18,9.44q-1.23,6-.81,8.79a6.58,6.58,0,0,1-1.42.34,2.85,2.85,0,0,1-1.7-.3,1.65,1.65,0,0,1-1-1.34,13.67,13.67,0,0,1,.62-4.5,68.32,68.32,0,0,1,2.2-6.85l-.12,0q-2.07,2.81-3.66,3.18c-.76.18-1.24-.17-1.45-1a8.87,8.87,0,0,0,2.75-2.16,47,47,0,0,0,3.92-4.68,3.22,3.22,0,0,1,2.1-1.67,1.81,1.81,0,0,1,1,.18A1.41,1.41,0,0,1,530.38,100.67Z",
    fill: "#fff"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377,350.09a1.9,1.9,0,0,1-1.17-.2,2.6,2.6,0,0,0,.71-1.84.71.71,0,0,0-.27-.49.78.78,0,0,0-.62-.12,2.63,2.63,0,0,0-1.62.91,2,2,0,0,0-.6,1.69.94.94,0,0,0,.07.31.89.89,0,0,0,.14.25l.16.18.23.15.23.11.27.11.24.09,1,.39a6.43,6.43,0,0,1,.79.42,2.18,2.18,0,0,1,.74.65,1.85,1.85,0,0,1,.31.86,2.38,2.38,0,0,1-.8,2.07,5.35,5.35,0,0,1-2.74,1.42,19.73,19.73,0,0,0-.38,3.08c-.86.11-1.32-.11-1.39-.65a5.78,5.78,0,0,1,.6-2.26,4.31,4.31,0,0,1-2-.32,1.55,1.55,0,0,1-1-1.29,1.34,1.34,0,0,1,.38-1.13,1.88,1.88,0,0,1,1.18-.58,1.92,1.92,0,0,1,.67,0,2.75,2.75,0,0,0,0,.69,1.83,1.83,0,0,0,.54,1.12,1.28,1.28,0,0,0,1.06.29,1.61,1.61,0,0,0,1.09-.56,1.44,1.44,0,0,0,.3-1.15.92.92,0,0,0-.34-.61,2.14,2.14,0,0,0-.55-.36,5.54,5.54,0,0,0-.78-.27,5.35,5.35,0,0,1-1.64-.83,2.11,2.11,0,0,1-.76-1.38,3.07,3.07,0,0,1,.92-2.59,5.65,5.65,0,0,1,3-1.62c.28-1.81.71-2.75,1.3-2.82a1.1,1.1,0,0,1,.55.08,1,1,0,0,1,.44.29,9.75,9.75,0,0,0-.9,2.3,3.28,3.28,0,0,1,1.76.41,1.58,1.58,0,0,1,.3,2.49A2.3,2.3,0,0,1,377,350.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.49,338.37a33.28,33.28,0,0,0-3.18,9.44q-1.23,6-.81,8.79a6.58,6.58,0,0,1-1.42.34,2.85,2.85,0,0,1-1.7-.3,1.65,1.65,0,0,1-1-1.34,13.75,13.75,0,0,1,.62-4.51,69,69,0,0,1,2.2-6.84l-.12,0q-2.07,2.8-3.66,3.18c-.76.18-1.24-.17-1.45-1a8.87,8.87,0,0,0,2.75-2.16,47,47,0,0,0,3.92-4.68,3.22,3.22,0,0,1,2.1-1.67,1.83,1.83,0,0,1,1,.18A1.41,1.41,0,0,1,390.49,338.37Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.42,337.11a32.84,32.84,0,0,0-3.19,9.44q-1.22,6-.81,8.78a6.07,6.07,0,0,1-1.41.34,2.79,2.79,0,0,1-1.71-.29,1.66,1.66,0,0,1-1-1.34,13.56,13.56,0,0,1,.63-4.51,65.49,65.49,0,0,1,2.19-6.84l-.12,0q-2.07,2.81-3.66,3.18c-.75.17-1.24-.17-1.44-1a8.9,8.9,0,0,0,2.75-2.17,47.45,47.45,0,0,0,3.92-4.68,3.23,3.23,0,0,1,2.09-1.67,1.81,1.81,0,0,1,1,.18A1.44,1.44,0,0,1,400.42,337.11Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgALaCarte);
export default __webpack_public_path__ + "static/media/ALaCarte.f56b8bf640ad8144573b47d1ae8e0614.svg";
export { ForwardRef as ReactComponent };